import { IDocIPV } from './../models/investor';
import { Injectable } from '@angular/core';
import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AddressDetails } from 'src/app/models/address-details';
import { Investor } from 'src/app/models/investor';
import { InvestorAccount } from 'src/app/models/investor-account';
import { InvestorDetails } from 'src/app/models/investor-details';
import { DocumentDetails } from '../models/document-details';
import { KycModification } from '../models/kyc-modification';
import { SegmentDetails } from '../models/segment-details';
import { OnboardingService } from '../services/rest/onboarding.service';
import { SharedService } from '../services/shared/shared.service';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import {Subject, Subscription} from 'rxjs';
import validationtext from '../../../src/json/validationmsg.js';
import { ActivatedRoute, Router } from '@angular/router';
import * as cryptoJs from 'crypto-js';
import { environment } from 'src/environments/environment';

/**Regex for PAN Number*/
const panNumberRegex = /^[a-zA-Z]{3}[pP]{1}[a-zA-Z]{1}[0-9]{4}[a-zA-Z]{1}$/;
/**Regex for mobile Number*/
const mobileNumberRegex = /^(6|9|8|7)([0-9]{9})$/;
/**Regex for emailID*/
const emailRegex = /^[A-Za-z0-9._%+-]{1,}@[a-zA-Z-]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})$/;
/**Regex for Name*/
const nameRegex = /^(?!.*[\s]{2,})(?!.*[\.]{2,})(?!.*[\']{2,})(?!.*[\-]{2,})(?=.{2,}$)(([A-Za-z\.\'\- ])\2?(?!\2))+$/;
/**Regex for city Name*/
const cityRegex = /^(?!.*[\s]{2,})([A-Za-z\s\-\.]){2,}$/;
/**Regex for Message*/
const messageRegex = /^(?!.*[ ]{2,})([A-Za-z0-9\s\'-:.,\(\[\]\)@]){1,}$/;
/**Regex for Address*/
const addressRegex = /^(?!.*[ ]{2,})([A-Za-z0-9\s\'-:.,~!\(\[\]\)]){2,}$/;
/**Regex for Pin Code*/
const pinCodeRegex = /^[1-9][0-9]{5}$/;
/**Regex for Account Number*/
const accNoRegex = /^([0-9]){8,18}$/;
/**Regex for OTP*/
const otpRegex = /^([0-9]){4}$/;
/**Regex for unified OTP*/
const unifiedotpRegex = /^([0-9]){6}$/;
/**Regex for IFSC Code*/
const ifscRegex = /^([A-Za-z0-9]){11}/;
/**Regex for userName*/
const userNameRegex = /^[a-z0-9]+$/i;
/** Regex for dob */
const dobRegex = /^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/;
/**Regex for Share Percent*/
const sharePercentRegex = /^[1-9]$|^[1-9][0-9]$|^(100)$/;
/**Regex for Indian Passport*/
const passportRegex = /^[A-PR-WYa-pr-wy][1-9]\d\s?\d{4}[1-9]$/;
/**Regex for Indian Voter ID*/
const voterRegex = /^([a-zA-Z]){3}([0-9]){7}?$/;
/**Regex for Aadhaar Number*/
const aadhaarRegex = /^\d{12}$/;
/**Regex for alphaNumeric*/
const alphaNumericRegex = /^[a-zA-Z0-9]+$/i;
/**Regex for MF Nominee Name*/
const nomineeNameRegex = /^(?!.*[\s]{2,})(?!.*[\.]{2,})(?!.*[\']{2,})(?!.*[\-]{2,})(([A-Za-z\'\- ])\2?(?!\2))+$/;

/**Configuration for Redirection based on BU */
const URLs = {
  'JF': {
    id: 2,

    loginURL: 'https://finx.choiceindia.com/auth/login',

    dashboardURL: 'https://finx.choiceindia.com/client/dashboard',

    tnc: 'https://finx.choiceindia.com/terms-use',

    privacyPolicy: 'https://finx.choiceindia.com/privacy-policy',

    leadCreationURL: 'https://finx.choiceindia.com/open-demat-account',

    alphabeeURL: 'https://alphabee.choicebroking.in',

    signUpURL: 'https://finx.choiceindia.com/open-demat-account',

    homePageURL: 'https://finx.choiceindia.com/',

    mfChoiceIndiaURL: 'https://mf.choiceindia.com'
  },
  'MFJF': {
    id: 2,

    loginURL: 'https://finx.choiceindia.com/auth/login',

    dashboardURL: 'https://finx.choiceindia.com/client/dashboard',

    tnc: 'https://finx.choiceindia.com/terms-use',

    privacyPolicy: 'https://finx.choiceindia.com/privacy-policy',

    leadCreationURL: 'https://finx.choiceindia.com/open-demat-account',

    signUpURL: 'https://finx.choiceindia.com/open-demat-account',

    homePageURL: 'https://finx.choiceindia.com/',

    mfChoiceIndiaURL: 'https://mf.choiceindia.com'
  },
  'MF': {
    id: 1,
    loginURL: 'https://investica.com/auth/sign-in',
    dashboardURL: 'https://investica.com/user/my-dashboard',
    tnc: 'https://investica.com/terms-of-use',
    privacyPolicy: 'https://investica.com/privacy-policy',
    leadCreationURL: 'https://investica.com/auth/sign-up',
    signUpURL: 'https://investica.com/auth/sign-up',
    mfChoiceIndiaURL: 'https://mf.choiceindia.com'
  }
}
/** Service Injectable */
@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  /**Holds flow points of forms */
  private utils: any;
  /** boolean whether the current browser is mobile or not */
  isMobile: boolean;
  /** String specifiying the current Business Unit*/
  businessUnit: string;
  /** Storage Object from window whichever is available */
  private storage: any;
  /** Investor DTO for holding Investor Data*/
  private investor: Investor;
  /** Configuration for component*/
  public config: any;
  /** Configuration for Modal*/
  public modalConfig: any;
  /** boolean whether the rest API Call is in progress */
  isServiceHit: boolean;
  /** Configuration for OTPModal */
  public otpFormModal: any;
  /** Modification DTO for holding Modification Data*/
  public modification: KycModification;
  /**Lang Data for Multilingual */
  public langData;
  /** Variable for holding selected Language */
  selectedLanguage: string;
  /** Variable for holding validation errors based on language */
  errorMessages: any;

  /**variable for holding secure params */
  secureParams: any;
 /** subject */
  subject = new Subject<any>();
  /** Account Closure */
  accountClosure :any;
  // subject2 = new Subject<any>(); 
  // subscription: Subscription;

  

  /**
   * Method to initialize Component
   * @param toastr instance of ToastrService
   * @param rest instance of OnboardingService
   * @param shared instance of SharedService
   * @param activatedRoute instance of ActivatedRoute
   * @param route instance of Router
   */
  constructor(private toastr: ToastrService, private rest: OnboardingService, private shared: SharedService, private activatedRoute: ActivatedRoute,private route: Router) {

    this.activatedRoute.queryParams.subscribe(params => {
      // console.log('inside subscripte')
      // this.secureParams = params;
      console.log(params,"params")
      for (const [key, value] of Object.entries(params)) {
        // if(key == 'invid'){
        //   let inv = value.replace(' ','+').toString();
        //   sessionStorage.setItem(`${key}`, inv)
        // }
        // else{
        //   sessionStorage.setItem(`${key}`, value.toString())
        // }
        let text = value.replaceAll(' ','+').toString();
        sessionStorage.setItem(`${key}`, text)
      }
      // if(sessionStorage.getItem('code') && sessionStorage.getItem('invid')){
      //   this.generateAccessToken();
      // }
    })
    
    // if(sessionStorage.getItem('code') && sessionStorage.getItem('invid')){
    sessionStorage.setItem('businessUnit',this.getBusinessUnit().toString())
    this.config = {};
    this.storage = window.sessionStorage //|| window.localStorage;
    this.storage = window.sessionStorage ;
    this.initializeConfig();
    this.isMobile = this.isMobileDevice();
    this.businessUnit = this.getBusinessUnit();
    this.investor = this.getOnboardingData() || new Investor();
    this.modification = this.getModificationData() || new KycModification();
    this.langData = {};
    // }

    // this.subscription = this.getMessage2().subscribe((res) => {
    //   console.log('POPUPLSDKFJ')
    //   this.showSessionExpiredPopup();
    // })
  }
/** FOR reset page step and screen */
  public resetStep(){
    this.initializeScreenList();
  }

  
/** show config Modal*/
  public showModal(config: any) {
    this.modalConfig = config;
  }
/** show config based OTPForm */
  public showOTPForm(config: any) {
    this.otpFormModal = config;
  }
/** Getting  Redirection URL*/
  public getRedirectionURL(key) {
    return URLs[this.businessUnit][key];
  }
/**
 * page load time initial configuration
 */
  private initializeConfig() {
    console.log('inside initializeConfig');
    this.initializeScreenList();
    this.selectedLanguage = this.getLanguage();
    this.setLanguage(this.selectedLanguage);
    this.getLangData(this.selectedLanguage)
    this.setValidationLang(); 
    this.initializeFlowPoints();
    console.log(location.pathname, "location.pathname utils");
    location.pathname.indexOf('respond-issue') > -1 ? (sessionStorage.setItem('requestFrom','raiseIssue'),sessionStorage.setItem('requestSource','raiseIssue')): location.href.indexOf('account-closure') > -1 ? sessionStorage.setItem('requestFrom','accountClosure') : location.pathname.indexOf('modification/trading') > -1 ? (sessionStorage.setItem('requestFrom','modification'),sessionStorage.setItem('requestSource','contactModification')) : location.pathname.indexOf('offline-onboard') > -1 ? (sessionStorage.setItem('requestFrom','offlineClientCreation'),sessionStorage.setItem('requestSource','offlineClientCreation')) : location.pathname.indexOf('modification/mf') > -1 ? (sessionStorage.setItem('requestFrom','addressModification'),sessionStorage.setItem('requestSource','addressModification')):
    (sessionStorage.setItem('requestFrom','onboarding'),sessionStorage.setItem('requestSource','objourneyModify'));
    if ((location.pathname.indexOf('/modification/trading/client-login') === -1)||(location.pathname.indexOf('/modification/mf/client-login') === -1)) {
      // this.initializeLeadCityList();
      // this.initializeLeadCityListV2('');
      this.initializeCountryList();
      if ((location.pathname.indexOf('/modification/trading/client-login') === -1)||(location.pathname.indexOf('/modification/mf/client-login') === -1)) {
      // this.initializeStateList();
      this.initializeStateListV2();
      // this.initializeIncomeSlabs();
      this.initializeOccupationList();
      // this.initializeEducationList();
      this.initializeEducationListV2();
    }
  }}
/**
 * GEt Lead City List
 */
  private initializeLeadCityList() {
    this.rest.retrieveLeadCityList().subscribe((res) => {
      if (res && (!res.errorCode && !res.error)) {
        this.config.leadCities = res;
      }
    });
  }

  /** Get Lead City List  version 2*/
  private initializeLeadCityListV2(cityname: any) {
    this.rest.retrieveLeadCityListV2(cityname).subscribe((res) => {
      if (res && (!res.errorCode && !res.error && res.Body.CityMasterList.length)) {
        this.config.leadCities = res.Body.CityMasterList;
      }
    });
  }
/** GEt Lead State List */
  private initializeStateList() {
    this.rest.retrieveStateLists().subscribe((res) => {
      if (res && (!res.errorCode && !res.error)) {
        this.config.states = res;
      }
    });
  }

  /**state list OPT V2 */
  private initializeStateListV2() {
    this.rest.retrieveStateListsV2().subscribe((res) => {
      if (res && (!res.errorCode && !res.error && res.Body.StateList.length)) {
        this.config.states = res.Body.StateList;
      }
    });
  }
/** initialize Income Slabs */
  private initializeIncomeSlabs() {
    this.rest.retrieveIncomeSlabLists().subscribe((res) => {
      if (res && (!res.errorCode && !res.error)) {
        this.config.incomeSlabs = res.filter((slab) => {
          return slab.slab != '>25L';
        });
      }
    });
  };
/**  initialize Occupation List */
  private initializeOccupationList() {
    this.rest.retrieveOccupationLists().subscribe((res) => {
      if (res && (!res.errorCode && !res.error)) {
        this.config.occupations = res;
      }
    });
  };
/** initialize Education List */
  private initializeEducationList() {
    this.rest.retrieveEducationLists().subscribe((res) => {
      if (res && (!res.errorCode && !res.error)) {
        this.config.educations = res;
      }
    });
  };
/** initialize total Screen List */
  private initializeScreenList() {
    let screensMap = {
      "onboard-info": { id: 1, JF: 1, MF: 1, MFJF: 1, event: 'on_info', screenName: 'info', label: 'Onboard Info' },
      "registration": { id: 2, JF: 2, MF: 2, MFJF: 2, event: 'on_register', screenName: 'register', label: 'Registration' },
      "open-account": { id: 3, JF: 3, MF: 3, MFJF: 3, event: 'on_pan', screenName: 'pan', label: 'Open Account' },
      "basic-details": { id: 4, JF: 4, MF: 4, MFJF: 4, event: 'on_basic', screenName: 'basic', label: 'Basic Details' },
      "address-details": { id: 5, JF: 5, MF: 5, MFJF: 5, event: 'on_address', screenName: 'address', label: 'Address Details' },
      "nominee-details": { id: 6, JF: 6, MF: 6, MFJF: 6, event: 'on_nominee', screenName: 'nominee', label: 'Nominee Details' },
      "income-details": { id: 7, JF: 7, MF: 7, MFJF: 7, event: 'on_income_fatca', screenName: 'income_fatca', label: 'Income Details' },
      "bank-details": { id: 8, JF: 8, MF: 8, MFJF: 8, event: 'on_bank', screenName: 'bank', label: 'Bank Details' },
      "segment-details": { id: 9, JF: 9, MF: 9, MFJF: 9, event: 'on_segments', screenName: 'segments', label: 'Segment Details' },
      "ipv-details": { id: 10, JF: 10, MF: 10, MFJF: 10, event: 'on_ipv', screenName: 'ipv', label: 'IPV Details' },
      "document-uploads": { id: 11, JF: 11, MF: 11, MFJF: 11, event: 'on_document', screenName: 'document', label: 'Document Uploads' },
      "brokerage-details": { id: 16, JF: 16, MF: 16, MFJF: 16, event: 'on_brokerage', screenName: 'brokerage' },
      "esign": { id: 12, JF: 12, MF: 12, MFJF: 12, event: 'on_esign', screenName: 'esign', label: 'E-sign' },
      "congrats": { id: 13, JF: 13, MF: 13, MFJF: 13, event: 'on_congrats', screenName: 'congrats', label: 'Congrats' },
      "digi-locker": { id: 15, JF: 15, MF: 15, MFJF: 15, event: 'on_digi-locker', screenName: 'digi-locker', label: 'Digi Locker' },
    };
    this.config.screens = screensMap;
    this.rest.retrieveScreenLists().subscribe((res) => {
      console.log(res, "this.config.screens")
      if (res && (!res.errorCode && !res.error)) {
        let screens = {};
        res.forEach((screen, index) => {
          screens[screen.name] = { screen: screen, step: screensMap[screen.name] };
        })
        this.config.screens = screens;
      }
    });
  };
/** initialize Country List */
  private initializeCountryList() {
    this.rest.retrieveCountryLists().subscribe((res) => {
      if (res && (!res.errorCode && !res.error)) {
        this.config.countries = res;
      }
    })
  }
/**
 * configuration base key value
 * @param key Geetin key value
 * @returns this key will join with config object
 */
  public getConfigList(key: string) {
    return this.config[key] || [];
  }
/**
 * Get Language Data
 * @param selectedLang passing selected Language
 * @returns passing message using through language
 */
  public getLangData(selectedLang: string) {
    return this.rest.getLanguageData(selectedLang).subscribe((response) => {
      if (response) {
        this.langData = response;
        this.sendMessage(selectedLang);
      }
    });
  }
  
/**
 * all platform key name mention here like (onboarding,modification,raise issue,offeline)
 * all platform validate of every key 
 * validation type
 * showing error message base on validation
 * identify MF or JF condition base 
 */
  private initializeFlowPoints() {
    let investorDateRange = this.getInvestorDOBRange();
    let nomineeDateRange = this.getNomineeDOBRange();
    this.utils = {
      'offline-onboard': {
        inputs: {
          panNumber: {
            validations: [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(panNumberRegex)],
            error: {
              required: this.errorMessages.pan_required,
              pattern: this.errorMessages.pan_pattern
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          dateOfBirth: {
            validations: [Validators.required, range(new Date(investorDateRange.min).valueOf(), new Date(investorDateRange.max).valueOf())],
            error: {
              required: this.errorMessages.dob_required,
              range: this.errorMessages.dob_range
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          mobileNumber: {
            MFValidators: [Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
            JFValidators: [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
            MFJFValidators: [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
            error: {
              required: this.errorMessages.mob_required,
              pattern: this.errorMessages.mob_pattern
            },
            MF: false,
            JF: true,
            MFJF: false,
          },
          email: {
            MFValidators: [Validators.pattern(emailRegex)],
            JFValidators: [Validators.required, Validators.pattern(emailRegex)],
            MFJFValidators: [Validators.required, Validators.pattern(emailRegex)],
            error: {
              required: this.errorMessages.email_required,
              pattern: this.errorMessages.email_pattern
            },
            JF: true,
            MFJF: true
          },
          referralCode: {
            MFValidators: [],
            JFValidators: [Validators.minLength(0), Validators.maxLength(20), Validators.pattern(/^[a-z0-9]+$/i)],
            MFJFValidators: [Validators.minLength(0), Validators.maxLength(20), Validators.pattern(/^[a-z0-9]+$/i)],
            error: {
              maxlength: this.errorMessages.reffcode_maxlength,
              pattern: this.errorMessages.reffcode_pattern,
            },
            JF: true,
            MFJF: true
          },
          leadCity: {
            MFValidators: [],
            JFValidators: [],
            MFJFValidators: [],
            error: {
              required: this.errorMessages.leadcity_required,
            },
            JF: false,
            MFJF: false
          },
          leadState: {
            MFValidators: [],
            JFValidators: [],
            MFJFValidators: [],
            error: {
              required: this.errorMessages.leadstate_required,
            },
            JF: false,
            MFJF: false
          },
          occupation: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.default_required,
              invalid: this.errorMessages.occupation_invalid
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          education: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.education_required,
            },
            JF: true
          },
          annualIncome: {
            validations: [Validators.required, Validators.min(1)],
            error: {
              pattern: this.errorMessages.annualInc_invalid,
              invalid: this.errorMessages.annualInc_invalid,
              required: this.errorMessages.annualInc_required
            },
            JF: true
          },
          politicalRelation: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.plRelation_required
            },
            JF: true
          },
          otherEducation: {
            validations: [],
            error: {
              required: this.errorMessages.default_required
            },
            JF: true
          },
          fullName: {
            validations: [Validators.required, Validators.minLength(2), Validators.pattern(nameRegex)],
            error: {
              required: this.errorMessages.fullname_required,
              pattern: this.errorMessages.fullname_invalid,
              minlength: this.errorMessages.name_minlength
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          fatherName: {
            validations: [Validators.required, Validators.minLength(2), Validators.pattern(nameRegex)],
            error: {
              required: this.errorMessages.fathername_required,
              pattern: this.errorMessages.fathername_invalid,
              minlength: this.errorMessages.name_minlength
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          motherName: {
            validations: [Validators.pattern(nameRegex), Validators.required],
            error: {
              required: this.errorMessages.mothername_required,
              pattern: this.errorMessages.mothername_invalid,
              minlength: this.errorMessages.name_minlength
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          isPolitics: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.default_required,
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          gender: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.default_required,
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          marital: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.default_required,
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          address: {
            validations: [],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: false,
            MF: true,
            MFJF: false
          },
          address1: {
            validations: [Validators.required, Validators.minLength(2)],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: true,
            MF: false,
            MFJF: true
          },
          address2: {
            validations: [Validators.required, Validators.minLength(2)],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: true,
            MF: false,
            MFJF: true
          },
          city: {
            validations: [Validators.required, Validators.minLength(2), Validators.pattern(cityRegex)],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.city_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          state: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.state_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          zipCode: {
            validations: [Validators.required, Validators.pattern(pinCodeRegex)],
            error: {
              required: this.errorMessages.zipcode_required,
              pattern: this.errorMessages.zipcode_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          isAddressSame: {
            JFValidators: [Validators.required],
            MFJFValidators: [Validators.required],
            JF: true,
            MF: false,
            MFJF: true
          },
          addressC: {
            JFValidators: [],
            MFJFValidators: [Validators.minLength(2)],
            MFValidators: [],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: false,
            MF: true,
            MFJF: false
          },
          addressC1: {
            JFValidators: [Validators.minLength(2)],
            MFJFValidators: [Validators.minLength(2)],
            MFValidators: [],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: true,
            MF: false,
            MFJF: true
          },
          addressC2: {
            JFValidators: [Validators.minLength(2)],
            MFJFValidators: [Validators.minLength(2)],
            MFValidators: [],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: true,
            MF: false,
            MFJF: true
          },
          cityC: {
            JFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
            MFValidators: [],
            MFJFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: true,
            MFJF: true
          },
          stateC: {
            JFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
            MFJFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
            MFValidators: [],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: true,
            MFJF: true
          },
          zipCodeC: {
            JFValidators: [Validators.pattern(pinCodeRegex)],
            MFJFValidators: [Validators.pattern(pinCodeRegex)],
            MFValidators: [],
            error: {
              required: this.errorMessages.zipcode_required,
              pattern: this.errorMessages.zipcode_invalid
            },
            JF: true,
            MFJF: true
          },
          birthCountry: {
            validations: [Validators.required, Validators.minLength(2), Validators.pattern(nameRegex)],
            error: {
              required: this.errorMessages.birthCountry_required,
              invalid: this.errorMessages.country_invalid
            },
            MF: true,
            MFJF: true,
            JF: true
          },
          taxResidency: {
            validations: [Validators.required, Validators.minLength(2), Validators.pattern(nameRegex)],
            error: {
              required: this.errorMessages.taxCountry_required,
              invalid: this.errorMessages.country_invalid
            },
            MF: true,
            MFJF: true,
            JF: true
          },
          /*  occupation: {
             JFValidators: [],
             MFJFValidators: [],
             MFValidators: [Validators.required],
             error: {
               required: this.errorMessages.default_required,
               invalid: this.errorMessages.occupation_invalid
             },
             MF: true,
             JF: false,
             MFJF: false
           }, */
          tinNumber: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              required: this.errorMessages.default_required,
            },
            MF: true,
            JF: false,
            MFJF: true
          },
          chequeFile: {
            validations: [Validators.required],
            error: {
              'required': this.errorMessages.cheque_required,
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          accountNumber: {
            validations: [Validators.required, Validators.pattern(accNoRegex)],
            error: {
              required: this.errorMessages.accNo_required,
              pattern: this.errorMessages.accNo_pattern
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          repeatAccountNumber: {
            validations: [Validators.required, Validators.pattern(accNoRegex)],
            error: {
              required: this.errorMessages.accNo_required,
              pattern: this.errorMessages.accNo_pattern,
              invalid: this.errorMessages.accNo_notmatch
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          ifsc: {
            validations: [Validators.required, Validators.pattern(ifscRegex)],
            error: {
              required: this.errorMessages.ifsc_required,
              pattern: this.errorMessages.ifsc_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          bankName: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.bankname_required
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          branch: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.bankbranchname_required
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          bankAddress: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.branchAdd_required
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          micr: {
            validations: [],
            JF: true,
            MF: true,
            MFJF: true
          },
          bankZipCode: {
            JFValidators: [Validators.pattern(pinCodeRegex)],
            MFJFValidators: [Validators.pattern(pinCodeRegex)],
            MFValidators: [],
            error: {
              required: this.errorMessages.zipcode_required,
              pattern: this.errorMessages.zipcode_invalid
            },
            JF: true,
            MFJF: true
          },
          accountType: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.accType_required
            },
            defaults: { JF: 'S', MF: 'S', MFJF: 'S' },
            JF: true,
            MF: true,
            MFJF: true
          },
          /*  segments: [
             {
               formControlName: 'NSECASH',
               formControlLabel: 'NSE CASH',
               id: '8a82b2b068bc46360168bc52702b0002',
               segmentName: "NSECash",
               segmentType: "Equity",
               validations: [],
               JF: true,
               MFJF: true
             },
             {
               formControlName: 'BSECash',
               formControlLabel: 'BSE CASH',
               id: '8a82b2b068bc46360168bc5271d80003',
               segmentName: "BSECash",
               segmentType: "Equity",
               validations: [],
               JF: true,
               MFJF: true
             },
             {
               formControlName: 'NSEFNO',
               formControlLabel: 'NSE F&O',
               id: '8a82b2b0689dbae201689dbb581e0001',
               segmentName: "NSEFNO",
               segmentType: "Derivatives",
               validations: [],
               JF: true,
               MFJF: true
             },
             {
               formControlName: 'BSEFNO',
               formControlLabel: 'BSE F&O',
               id: '8a82b2b068bc46360168bc5272fe0006',
               segmentName: "BSEFNO",
               segmentType: "Derivatives",
               validations: [],
               JF: true,
               MFJF: true,
               hidden: true
             },
             {
               formControlName: 'NSECDS',
               formControlLabel: 'NSE CURRENCY',
               id: '8a82b2b068bc46360168bc5272320004',
               segmentName: "NSECDS",
               segmentType: "Equity",
               validations: [],
               JF: true,
               MFJF: true
             },
             {
               formControlName: 'BSECDS',
               formControlLabel: 'BSE CURRENCY',
               id: '8a82b2b068bc46360168bc52729b0005',
               segmentName: "BSECDS",
               segmentType: "Equity",
               validations: [],
               JF: true,
               MFJF: true,
               hidden: true
             },
             {
               formControlName: 'MCX',
               formControlLabel: 'MCX',
               id: '8a82b2b068bc46360168bc526e3c0000',
               segmentName: "MCX",
               segmentType: "Commodity",
               validations: [],
               JF: true,
               MFJF: true
             },
             {
               formControlName: 'NCDEX',
               formControlLabel: 'NCDEX',
               id: '8a82b2b068bc46360168bc526f570001',
               segmentName: "NCDEX",
               segmentType: "Commodity",
               validations: [],
               JF: true,
               MFJF: true
             }
           ], */
          /*           plans: {
                      selected: 'Life Time AMC Plan',
                      disabled: true,
                      controls: [
                        { id: 'Life Time AMC Plan', value: 'Life Time AMC Plan', desc: '<strong>&#8377; 1,500 + 18% GST</strong>' },
                        { id: 'Zero AMC Plan', value: 'Zero AMC Plan', desc: 'NIL with <strong>&#8377; 3,000 Refundable Deposit</strong>. Deposit will be refunded at the time of closing of Demat Account.' },
                        { id: 'Annual AMC Plan', value: 'Annual AMC Plan', desc: '<strong>&#8377;  200+18% GST </strong>(Free for 1st Year)' }
                      ],
                      validations: [],
                      JF: true,
                      MFJF: true
                    }, */
          ipvFile: {
            validations: [],
            error: {
              'required': this.errorMessages.ipvFile_required,
              'fileType': this.errorMessages.default_fileType2,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          panCardFile: {
            JFValidators: [Validators.required],
            MFJFValidators: [Validators.required],
            MFValidators: [Validators.required],
            error: {
              'required': this.errorMessages.panFile_required,
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          photoFile: {
            validations: [Validators.required],
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              'required': this.errorMessages.photoFile_required,
              'fileType': this.errorMessages.default_fileType2,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          signFile: {
            validations: [Validators.required],
            error: {
              'required': this.errorMessages.signFile_required,
              'fileType': this.errorMessages.default_fileType2,
              'fileSize': this.errorMessages.default_fileSize3
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          addrProofType: {
            JFValidators: [Validators.required],
            MFJFValidators: [Validators.required],
            MFValidators: [Validators.required],
            error: {
              'required': this.errorMessages.addproof_required,
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          addrProofFrontFile: {
            JFValidators: [Validators.required],
            MFJFValidators: [Validators.required],
            MFValidators: [Validators.required],
            error: {
              'required': 'Please Click/Upload Valid Address Proof.',
              'fileType': 'Please upload file having extensions jpeg, jpg, and png only.',
              'fileSize': 'Maximum Allowed File size is 10MB.',
              'fileSize2': 'Maximum Allowed File size is 10MB.',
              'fileTypeadhaar': 'Please upload file having extensions jpeg, jpg and png only.',
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          addrProofRearFile: {
            validations: [],
            error: {
              'required': 'Please Click/Upload Valid Address Proof.',
              'fileType': 'Please upload file having extensions jpeg, jpg, and png only.',
              'fileSize': 'Maximum Allowed File size is 10MB.',
              'fileSize2': 'Maximum Allowed File size is 10MB.',
              'fileTypeadhaar': 'Please upload file having extensions jpeg, jpg and png only.',
            },
            JF: true,
            MF: true,
            MFJF: true,
            hidden: true
          },
          ismaskingadhaar:{
            JFValidators: [Validators.required],
            MFJFValidators: [Validators.required],
            MFValidators: [Validators.required],
            JF: true,
            MF: true,
            MFJF: true,
          },

          overseasAddressFrontFile: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              'required': this.errorMessages.overseasAddProof_required,
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: false,
            MF: true,
            MFJF: false
          },
          overseasAddressRearFile: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              'required': this.errorMessages.overseasAddProof_required,
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: false,
            MF: true,
            MFJF: false
          },
          passportFrontFile: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              'required': this.errorMessages.passportFile_required,
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: false,
            MF: true,
            MFJF: false
          },
          passportRearFile: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              'required': this.errorMessages.passportFile_required,
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: false,
            MF: true,
            MFJF: false
          },
          visaFile: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              'required': this.errorMessages.uploadVisa_required,
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: false,
            MF: true,
            MFJF: false
          },
          incomeProofType: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              'required': this.errorMessages.incProof_required,
            },
            JF: true,
            MF: false,
            MFJF: true
          },
          incomeProofFile: {
            validations: [],
            error: {
              'required': this.errorMessages.incProofFile_required,
              'fileType': this.errorMessages.default_fileType_incomeproof,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: true,
            MF: false,
            MFJF: true
          },
          aof: {
            validations: [Validators.required],
            error: {
              'required': this.errorMessages.aofFile_required,
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: true,
            MF: false,
            MFJF: true
          },
          plans: {
            selected: 'Annual AMC Plan',
            disabled: true,
            controls: [
              { id: 'Annual AMC Plan', value: 'Annual AMC Plan', desc: '<strong>&#8377;  200+18% GST </strong><span class="info-style">(Free for 1st Year)</span>' },
              { id: 'Life Time AMC Plan', value: 'Life Time AMC Plan', desc: '<strong>&#8377; 1,500 + 18% GST</strong>' },
              { id: 'Zero AMC Plan', value: 'Zero AMC Plan', desc: 'NIL with <strong>&#8377; 3,000 Refundable Deposit</strong>. Deposit will be refunded at the time of closing of Demat Account.' },
              {id:'First Three Years AMC Free Plan' ,value:'First Three Years AMC Free Plan',desc:''},
              {id:'BSDA',value:'BSDA',desc:''}
            ],
            validations: [],
            JF: false,
            MFJF: true
          },
        },
      },
      'onboard-info': {
        inputs: {
          panNumber: {
            validations: [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(panNumberRegex)],
            error: {
              required: this.errorMessages.pan_required,
              pattern: this.errorMessages.pan_pattern2
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          dateOfBirth: {
            validations: [Validators.required, range(new Date(investorDateRange.min).valueOf(), new Date(investorDateRange.max).valueOf())],
            error: {
              required: this.errorMessages.dob_required,
              range: this.errorMessages.dob_range,
              pattern: this.errorMessages.invalidFormat
            },
            MF: true,
            JF: true,
            MFJF: true
          }
        },
        getForwardRoute: (investor: Investor) => {
          investor = investor || this.investor;
          if (investor && investor.id) {
            let investorAccount = this.getInvestorAccount(investor);
            if (investorAccount.isOnBoardFlag == 'Y') {
              return { 'error': 'Your onboarding is already completed. You will receive login credentials on your registered email ID within next few hours', 'onboardFlag': investorAccount.isOnBoardFlag }
            } else if (investorAccount.isOnBoardFlag == 'C') {
              return this.businessUnit == 'MF' ? { 'error': 'Congratualtions. Your account is already active with us.  Login to Investica with your client ID ' + investorAccount.clientID + '. You would have received the login credentials in your e-mail', 'onboardFlag': investorAccount.isOnBoardFlag } : this.businessUnit == 'JF' ? { 'error': 'Congratualtions. Your account is already active with us.  Login to Choice FinX/Alphabee with your client ID ' + investorAccount.clientID + '. You would have received the login credentials in your e-mail', 'onboardFlag': investorAccount.isOnBoardFlag } : '';
            }
            // if (investorAccount.isOnBoardFlag == 'Y' || investorAccount.isOnBoardFlag == 'C') {
            //   return this.businessUnit == 'MF' ? { 'error': 'This PAN is already associated with another account. Please Login or contact support team' } :
            //     this.businessUnit == 'JF' ? { 'error': investorAccount.clientID ? 'Client associated with this pan already exists. Please Login' : 'Your Onboarding is Completed, You will recieve your credentials soon.' } : '';
            // }
            else if (investorAccount && investorAccount.isOnBoardFlag == 'N') {
              return this.getForwardRoute(investor, this.businessUnit);
            }
          } else {
            return this.getForwardRoute(investor, this.businessUnit);
          }
        },
        getBackwardRoute: () => {
        }
      },
      'registration': {
        inputs: {
          mobileNumber: {
            validations: [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
            error: {
              required: this.errorMessages.mob_required,
              pattern: this.errorMessages.mob_pattern
            },
            MF: true
          },
          userName: {
            validations: [Validators.required, Validators.minLength(6), Validators.maxLength(10), Validators.pattern(userNameRegex)],
            error: {
              required: this.errorMessages.userid_required,
              pattern: this.errorMessages.username_pattern,
              maxlength: this.errorMessages.username_maxlength,
              minlength: this.errorMessages.username_minlength,
              exist: this.errorMessages.userid_exists
            },
            MF: true
          },
          email: {
            validations: [Validators.required, Validators.pattern(emailRegex)],
            error: {
              required: this.errorMessages.email_required,
              pattern: this.errorMessages.email_invalid
            },
            MF: true
          },
          password: {
            validations: [Validators.required, Validators.minLength(6), Validators.maxLength(20)],
            error: {
              required: this.errorMessages.password_required,
              pattern: this.errorMessages.email_invalid
            },
            MF: true
          },
          referralCode: {
            MFValidators: [Validators.minLength(0), Validators.maxLength(20), Validators.pattern(/^[a-z0-9]+$/i)],
            JFValidators: [],
            error: {
              maxlength: this.errorMessages.reffcode_maxlength,
              pattern: this.errorMessages.reffcode_pattern,
            },
            MF: true
          }
        },
        getForwardRoute: (investor?: Investor) => {
          investor = investor || this.investor;
          if (investor && investor.id) {
            return this.businessUnit == 'MF' ? this.getForwardRoute(investor, 'MF') : { 'error': this.errorMessages.move_forward };
          }
        },
        getBackwardRoute: () => {
        }
      },
      'otp-popup': {
        inputs: {
          mobOtp: {
            validations: [Validators.pattern(unifiedotpRegex)],
            error: {
              required: this.errorMessages.otp_required,
              pattern: this.errorMessages.unifiedotp_pattern
            },
            MF: true,
            JF: true
          },
          emailOtp: {
            validations: [Validators.pattern(unifiedotpRegex)],
            error: {
              required: this.errorMessages.otp_required,
              pattern: this.errorMessages.unifiedotp_pattern
            },
            MF: true,
            JF: true
          }
        }
      },
      'open-account': {
        inputs: {
          mobileNumber: {
            MFValidators: [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
            JFValidators: [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
            MFJFValidators: [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
            error: {
              required: this.errorMessages.mob_required,
              pattern: this.errorMessages.mob_pattern
            },
            MF: true,
            JF: true,
            MFJF: false,
          },
          email: {
            MFValidators: [Validators.required, Validators.pattern(emailRegex)],
            JFValidators: [Validators.required, Validators.pattern(emailRegex)],
            MFJFValidators: [Validators.required, Validators.pattern(emailRegex)],
            error: {
              required: this.errorMessages.email_required,
              pattern: this.errorMessages.email_invalid
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          referralCode: {
            MFValidators: [],
            JFValidators: [Validators.minLength(0), Validators.maxLength(20), Validators.pattern(/^[a-z0-9]+$/i)],
            MFJFValidators: [Validators.minLength(0), Validators.maxLength(20), Validators.pattern(/^[a-z0-9]+$/i)],
            error: {
              maxlength: this.errorMessages.reffcode_maxlength,
              pattern: this.errorMessages.reffcode_pattern,
              invalid: this.errorMessages.reffCode_invalid
            },
            MF: false,
            JF: true,
            MFJF: false
          },
          leadCity: {
            MFValidators: [],
            JFValidators: [],
            MFJFValidators: [],
            error: {
              required: this.errorMessages.leadcity_required,
            },
            MF: false,
            JF: false,
            MFJF: false
          },
          leadState: {
            MFValidators: [],
            JFValidators: [],
            MFJFValidators: [],
            error: {
              required: this.errorMessages.leadstate_required,
            },
            MF: false,
            JF: false,
            MFJF: false
          },
          occupation: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.default_required,
              invalid: this.errorMessages.occupation_invalid
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          education: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.education_required,
            },
            JF: true,
            MF: true
          },
          annualIncome: {
            validations: [Validators.required, Validators.min(1)],
            error: {
              pattern: this.errorMessages.annualInc_invalid,
              invalid: this.errorMessages.annualInc_invalid,
              required: this.errorMessages.annualInc_required
            },
            JF: true,
            MF: true
          },
          politicalRelation: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.plRelation_required
            },
            JF: true,
            MF: true
          },
          otherEducation: {
            validations: [],
            error: {
              required: this.errorMessages.default_required
            },
            JF: true,
            MF: true
          }
        },
        getForwardRoute: (investor?: Investor) => {
          investor = investor || this.investor;
          if (investor && investor.id) {
            return this.getForwardRoute(investor, this.businessUnit);
          }
        },
        getBackwardRoute: () => {
        }
      },
      'recover-account': {
        inputs: {
          otp: {
            MFValidators: [Validators.required, Validators.pattern(otpRegex)],
            error: {
              required: this.errorMessages.otp_required,
              pattern: this.errorMessages.otp_pattern
            },
            MF: true
          }
        },
        getForwardRoute: (investor?: Investor) => {
          investor = investor || this.investor;
          if (investor && investor.id) {
            return this.getForwardRoute(investor, this.businessUnit);
          }
          return this.getForwardRoute(investor, this.businessUnit);
        },
        getBackwardRoute: () => {
        }
      },
      'digi-locker': {
        getForwardRoute: (investor?: Investor) => {
          investor = investor || this.investor;
          if (investor && investor.id) {
            return this.getForwardRoute(investor, this.businessUnit);
          }
        },
        getBackwardRoute: () => {
        }
      },
      'basic-details': {
        inputs: {
          fullName: {
            validations: [Validators.required, Validators.minLength(2), Validators.pattern(nameRegex)],
            error: {
              required: this.errorMessages.fullname_required,
              pattern: this.errorMessages.fullname_invalid,
              minlength: this.errorMessages.name_minlength
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          fatherName: {
            validations: [Validators.required, Validators.minLength(2), Validators.pattern(nameRegex)],
            error: {
              required: this.errorMessages.fathername_required,
              pattern: this.errorMessages.fathername_invalid,
              minlength: this.errorMessages.name_minlength
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          motherName: {
            validations: [Validators.pattern(nameRegex), Validators.required],
            error: {
              required: this.errorMessages.mothername_required,
              pattern: this.errorMessages.mothername_invalid,
              minlength: this.errorMessages.name_minlength
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          isPolitics: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.default_required,
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          gender: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.default_required,
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          marital: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.default_required,
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          isNomineeSkipped: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.default_required,
            },
            MF: false,
            JF: false,
            MFJF: false
          }
        },
        getForwardRoute: (investor?: Investor) => {
          investor = investor || this.investor;
          if (investor && investor.id) {
            return this.getForwardRoute(investor, this.businessUnit);
          }
        },
        getBackwardRoute: () => {
        }
      },
      'kyc-aadhar': {
        esignURL: '',
        successURL: '/nsdlekyc/succRes.jsp',
        failureURL: '/nsdlekyc/failRes.jsp',
        getForwardRoute: (investor?: Investor) => {
          investor = investor || this.investor;
          if (investor && investor.id) {
            return this.getForwardRoute(investor, this.businessUnit);
          }
        },
        getBackwardRoute: () => {
        }
      },
      'address-details': {
        inputs: {
          address: {
            validations: [Validators.required, Validators.minLength(2)],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: false,
            MF: true,
            MFJF: true
          },
          address1: {
            validations: [Validators.required, Validators.minLength(2)],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: true,
            MF: false,
            MFJF: false
          },
          address2: {
            validations: [Validators.required, Validators.minLength(2)],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: true,
            MF: false,
            MFJF: false
          },
          city: {
            validations: [Validators.required, Validators.minLength(2), Validators.pattern(cityRegex)],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.city_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          state: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.state_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          zipCode: {
            validations: [Validators.required, Validators.pattern(pinCodeRegex)],
            error: {
              required: this.errorMessages.zipcode_required,
              pattern: this.errorMessages.zipcode_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          isAddressSame: {
            JFValidators: [Validators.required],
            MFJFValidators: [Validators.required],
            JF: true,
            MF: false,
            MFJF: true
          },
          addressC: {
            JFValidators: [Validators.minLength(2)],
            MFJFValidators: [Validators.minLength(2)],
            MFValidators: [],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: false,
            MFJF: true
          },
          addressC1: {
            JFValidators: [Validators.minLength(2)],
            MFJFValidators: [Validators.minLength(2)],
            MFValidators: [],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: true,
            MF: false,
            MFJF: false
          },
          addressC2: {
            JFValidators: [Validators.minLength(2)],
            MFJFValidators: [Validators.minLength(2)],
            MFValidators: [],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: true,
            MF: false,
            MFJF: false
          },
          cityC: {
            JFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
            MFValidators: [],
            MFJFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: true,
            MFJF: true
          },
          stateC: {
            JFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
            MFJFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
            MFValidators: [],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: true,
            MFJF: true
          },
          zipCodeC: {
            JFValidators: [Validators.pattern(pinCodeRegex)],
            MFJFValidators: [Validators.pattern(pinCodeRegex)],
            MFValidators: [],
            error: {
              required: this.errorMessages.zipcode_required,
              pattern: this.errorMessages.zipcode_invalid
            },
            JF: true,
            MFJF: true
          },
        },
        getForwardRoute: (investor?: Investor) => {
          investor = investor || this.investor;
          if (investor && investor.id) {
            return this.getForwardRoute(investor, this.businessUnit);
          }
        },
        getBackwardRoute: () => {
        }
      },
      'nominee-details': {
        inputs: {
          name: {
            JFValidators: [Validators.required, Validators.minLength(2), Validators.pattern(nameRegex)],
            MFValidators: [Validators.required, Validators.minLength(2), Validators.pattern(nomineeNameRegex)],
            MFJFValidators: [Validators.required, Validators.minLength(2), Validators.pattern(nameRegex)],
            error: {
              required: this.errorMessages.nominee_required,
              pattern: this.errorMessages.name_invalid,
              sameName:this.errorMessages.nominee_same
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          mobileNum: {
            JFValidators: [Validators.required,Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
            MFValidators: [Validators.required,Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
            MFJFValidators: [Validators.required,Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
            // validations: [Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
            error: {
              required:  this.errorMessages.mob_required,
              pattern:  this.errorMessages.mob_pattern
            },
            MF: true,
            JF: true,
            MFJF: true,
          },
          email: {
            // validations: [Validators.pattern(emailRegex)],
            JFValidators: [Validators.required,Validators.pattern(emailRegex)],
            MFValidators: [Validators.required,Validators.pattern(emailRegex)],
            MFJFValidators: [Validators.required,Validators.pattern(emailRegex)],
            error: {
              required: this.errorMessages.email_required,
              pattern: this.errorMessages.email_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          dob: {
            // validations: [Validators.required],
            JFValidators: [Validators.required],
            MFValidators: [],
            MFJFValidators: [],
            error: {
              required: this.errorMessages.dob_required,
              range: this.errorMessages.dob_range,
              pattern: this.errorMessages.invalidFormat
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          isMinor: {
            // validations: [],
            JFValidators: [],
            MFValidators: [],
            MFJFValidators: [],
            error: {
              required: this.errorMessages.dob_required
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          isAddrSameAsApplicant: {
            // validations: [Validators.required],
            JFValidators: [Validators.required],
            MFValidators: [],
            MFJFValidators: [],
            error: {
              required: this.errorMessages.default_required
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          isNomineeMinor: {
            // validations: [Validators.required],
            JFValidators: [],
            MFValidators: [],
            MFJFValidators: [],
            error: {
              required: this.errorMessages.default_required
            },
            MF: false,
            JF: false,
            MFJF: false
          },
          isShowNomineeForm: {
            // validations: [Validators.required],
            JFValidators: [],
            MFValidators: [],
            MFJFValidators: [],
            error: {
              required: this.errorMessages.default_required
            },
            MF: false,
            JF: false,
            MFJF: false
          },
          address: {
            validations: [],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: false,
            MF: false,
            MFJF: false
          },
          address1: {
            // validations: [Validators.required, Validators.minLength(2)],
            JFValidators: [Validators.required, Validators.minLength(2)],
            MFValidators: [Validators.minLength(2)],
            MFJFValidators: [Validators.minLength(2)],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          address2: {
            // validations: [Validators.required, Validators.minLength(2)],
            JFValidators: [Validators.required, Validators.minLength(2)],
            MFValidators: [Validators.minLength(2)],
            MFJFValidators: [Validators.minLength(2)],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          city: {
            // validations: [Validators.required, Validators.minLength(2), Validators.pattern(cityRegex)],
            JFValidators: [Validators.required, Validators.minLength(2), Validators.pattern(cityRegex)],
            MFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
            MFJFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.city_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          state: {
            // validations: [Validators.required],
            JFValidators: [Validators.required],
            MFValidators: [],
            MFJFValidators: [],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.state_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          zipCode: {
            // validations: [Validators.required, Validators.pattern(pinCodeRegex)],
            JFValidators: [Validators.required, Validators.pattern(pinCodeRegex)],
            MFValidators: [Validators.pattern(pinCodeRegex)],
            MFJFValidators: [Validators.pattern(pinCodeRegex)],
            error: {
              required: this.errorMessages.zipcode_required,
              pattern: this.errorMessages.zipcode_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          relation: {
            // validations: [Validators.required],
            JFValidators: [Validators.required],
            MFValidators: [Validators.required],
            MFJFValidators: [Validators.required],
            error: {
              required: this.errorMessages.nomineeRelation_required
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          shares: {
            // validations: [Validators.required, Validators.pattern(sharePercentRegex)],
            JFValidators: [Validators.required, Validators.pattern(sharePercentRegex)],
            MFValidators: [Validators.required, Validators.pattern(sharePercentRegex)],
            MFJFValidators: [Validators.required, Validators.pattern(sharePercentRegex)],
            error: {
              required: this.errorMessages.sharePrcnt_required,
              pattern: this.errorMessages.sharePrcnt_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          proofType: {
            // validations: [Validators.required],
          JFValidators: [Validators.required],
            MFValidators: [Validators.required],
            MFJFValidators: [Validators.required],
            error: {
              'required': this.errorMessages.doctype_required
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          documentId: {
            // validations: [Validators.required],
            JFValidators: [Validators.required],
            MFValidators: [Validators.required],
            MFJFValidators: [Validators.required],
            error: {
              'required': this.errorMessages.docID_required,
              'pattern': this.errorMessages.docID_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          proofFileName1: {
            // validations: [Validators.required],
            JFValidators: [Validators.required],
            MFValidators: [],
            MFJFValidators: [],
            error: {
              'required': this.errorMessages.defaultUpload_valid,
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          proofFileName2: {
            // validations: [],
            JFValidators: [],
            MFValidators: [],
            MFJFValidators: [],
            error: {
              // 'required': this.errorMessages.defaultUpload_valid,
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          guardianName: {
            // validations: [Validators.minLength(2), Validators.pattern(nameRegex)],
            JFValidators: [Validators.minLength(2), Validators.pattern(nameRegex)],
            MFValidators: [Validators.minLength(2), Validators.pattern(nameRegex)],
            MFJFValidators: [Validators.minLength(2), Validators.pattern(nameRegex)],
            error: {
              required: this.errorMessages.guardianname_required,
              pattern: this.errorMessages.guardianname_invalid
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          gdMobileNum: {
            // validations: [Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
            JFValidators: [Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
            MFValidators: [Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
            MFJFValidators: [Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
            error: {
              required: this.errorMessages.mob_required,
              pattern: this.errorMessages.mob_pattern
            },
            MF: true,
            JF: true,
            MFJF: true,
          },
          gdEmail: {
            // validations: [Validators.pattern(emailRegex)],
            JFValidators: [Validators.pattern(emailRegex)],
            MFValidators: [Validators.pattern(emailRegex)],
            MFJFValidators: [Validators.pattern(emailRegex)],
            error: {
              required: this.errorMessages.email_required,
              pattern: this.errorMessages.email_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          gdisAddrSameAsApplicant: {
            // validations: [Validators.required],
            JFValidators: [Validators.required],
            MFValidators: [],
            MFJFValidators: [],
            error: {
              required: this.errorMessages.default_required
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          gdAddress: {
            JFValidators: [],
            MFValidators: [],
            MFJFValidators: [],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.guardianAdd_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          gdAddress1: {
            // validations: [Validators.required, Validators.minLength(2)],
            JFValidators: [Validators.required, Validators.minLength(2)],
            MFValidators: [Validators.minLength(2)],
            MFJFValidators: [Validators.minLength(2)],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          gdAddress2: {
            // validations: [Validators.required, Validators.minLength(2)],
            JFValidators: [Validators.required, Validators.minLength(2)],
            MFValidators: [Validators.minLength(2)],
            MFJFValidators: [Validators.minLength(2)],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          gdCity: {
            // validations: [Validators.required, Validators.minLength(2), Validators.pattern(cityRegex)],
            JFValidators: [Validators.required, Validators.minLength(2), Validators.pattern(cityRegex)],
            MFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
            MFJFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.city_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          gdState: {
            // validations: [Validators.required, Validators.minLength(2), Validators.pattern(cityRegex)],
            JFValidators: [Validators.required, Validators.minLength(2), Validators.pattern(cityRegex)],
            MFValidators: [Validators.pattern(cityRegex)],
            MFJFValidators: [Validators.pattern(cityRegex)],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          gdZipCode: {
            // validations: [Validators.required, Validators.pattern(pinCodeRegex)],
            JFValidators: [Validators.required, Validators.pattern(pinCodeRegex)],
            MFValidators: [Validators.pattern(pinCodeRegex)],
            MFJFValidators: [Validators.pattern(pinCodeRegex)],
            error: {
              required: this.errorMessages.zipcode_required,
              pattern: this.errorMessages.zipcode_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          gdRelation: {
            // validations: [Validators.required],
            JFValidators: [Validators.required],
            MFValidators: [Validators.required],
            MFJFValidators: [Validators.required],
            error: {
              'required': this.errorMessages.defaultRelation_required
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          gdProofType: {
            // validations: [Validators.required],
            JFValidators: [],
            MFValidators: [],
            MFJFValidators: [],
            error: {
              'required': this.errorMessages.doctype_required
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          gdDocumentId: {
            // validations: [Validators.required, Validators.pattern(panNumberRegex)],
            JFValidators: [],
            MFValidators: [],
            MFJFValidators: [],
            error: {
              // 'required': this.errorMessages.docID_required,
              'pattern': this.errorMessages.docID_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          gdproofFileName1: {
            // validations: [Validators.required],
            // JFValidators: [Validators.required],
            MFValidators: [],
            MFJFValidators: [],
            error: {
              // 'required': this.errorMessages.defaultUpload_valid,
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          gdproofFileName2: {
            // validations: [],
            JFValidators: [],
            MFValidators: [],
            MFJFValidators: [],
            error: {
              // 'required': this.errorMessages.defaultUpload_valid,
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          // isNomAddrSame: {
          //   JFValidators: [Validators.required],
          //   MFValidators: [],
          //   MFJFValidators: [Validators.required],
          //   JF: true,
          //   MFJF: true
          // },
          // nomIsMinor: {
          //   validations: [Validators.required],
          //   MF: true,
          //   JF: true,
          //   MFJF: true
          // },
          // nomDOB: {
          //   validations: [range(new Date(nomineeDateRange.min).valueOf(), new Date(nomineeDateRange.max).valueOf())],
          //   error: {
          //     required: 'Nominee DOB is required if Nominee is Minor',
          //     range: 'Nominee age cannot be greater than 18 years.'
          //   },
          //   MF: true,
          //   JF: true,
          //   MFJF: true
          // },
          // nomAddress: {
          //   JFValidators: [Validators.minLength(2), Validators.pattern(addressRegex)],
          //   MFValidators: [],
          //   MFJFValidators: [Validators.minLength(2), Validators.pattern(addressRegex)],
          //   error: {
          //     required: this.errorMessages.default_required,
          //     pattern: 'Invalid Nominee Address'
          //   },
          //   JF: true,
          //   MFJF: true
          // },
          // nomCity: {
          //   JFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
          //   MFJFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
          //   error: {
          //     required: this.errorMessages.default_required,
          //     pattern: this.errorMessages.city_invalid
          //   },
          //   JF: true,
          //   MFJF: true
          // },
          // nomState: {
          //   JFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
          //   MFJFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
          //   MFValidators: [],
          //   error: {
          //     required: this.errorMessages.default_required,
          //     pattern: this.errorMessages.address_invalid
          //   },
          //   JF: true,
          //   MFJF: true
          // },
          // nomZipCode: {
          //   JFValidators: [Validators.pattern(pinCodeRegex)],
          //   MFJFValidators: [Validators.pattern(pinCodeRegex)],
          //   MFValidators: [],
          //   error: {
          //     required: this.errorMessages.zipcode_required,
          //     pattern: this.errorMessages.zipcode_invalid
          //   },
          //   JF: true,
          //   MFJF: true
          // },
        },
        getForwardRoute: (investor?: Investor) => {
          investor = investor || this.investor;
          if (investor && investor.id) {
            return this.getForwardRoute(investor, this.businessUnit);
          }
        },
        getBackwardRoute: () => {
        }
      },
      'bank-details': {
        inputs: {
          chequeFile: {
            validations: [],
            error: {
              'required': this.errorMessages.cheque_required,
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          accountNumber: {
            validations: [Validators.required, Validators.pattern(accNoRegex)],
            error: {
              required: this.errorMessages.accNo_required,
              pattern: this.errorMessages.accNo_pattern
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          repeatAccountNumber: {
            validations: [Validators.required, Validators.pattern(accNoRegex)],
            error: {
              required: this.errorMessages.accNo_required,
              pattern: this.errorMessages.accNo_pattern,
              invalid: this.errorMessages.accNo_notmatch
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          ifsc: {
            validations: [Validators.required, Validators.pattern(ifscRegex)],
            error: {
              required: this.errorMessages.ifsc_required,
              pattern: this.errorMessages.ifsc_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          bankName: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.bankname_required
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          branch: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.bankbranchname_required
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          bankAddress: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.branchAdd_required
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          micr: {
            validations: [],
            JF: true,
            MF: true,
            MFJF: true
          },
          bankZipCode: {
            JFValidators: [Validators.pattern(pinCodeRegex)],
            MFJFValidators: [Validators.pattern(pinCodeRegex)],
            MFValidators: [],
            error: {
              required: this.errorMessages.zipcode_required,
              pattern: this.errorMessages.zipcode_invalid
            },
            JF: true,
            MFJF: true
          },
          accountType: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.accType_required
            },
            defaults: { JF: 'S', MF: 'S', MFJF: 'S' },
            JF: true,
            MF: true,
            MFJF: true
          }
        },
        getForwardRoute: (investor?: Investor) => {
          investor = investor || this.investor;
          if (investor && investor.id) {
            return this.getForwardRoute(investor, this.businessUnit);
          }
        },
        getBackwardRoute: () => {
        }
      },
      'income-details': {
        inputs: {
          birthCountry: {
            validations: [Validators.required, Validators.minLength(2), Validators.pattern(nameRegex)],
            error: {
              required: this.errorMessages.birthCountry_required,
              invalid: this.errorMessages.country_invalid
            },
            MF: true,
            MFJF: true,
            JF: true
          },
          taxResidency: {
            validations: [Validators.required, Validators.minLength(2), Validators.pattern(nameRegex)],
            error: {
              required: this.errorMessages.taxCountry_required,
              invalid: this.errorMessages.country_invalid
            },
            MF: true,
            MFJF: true,
            JF: true
          },
          occupation: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [Validators.required],
            error: {
              required: this.errorMessages.default_required,
              invalid: this.errorMessages.occupation_invalid
            },
            MF: true,
            JF: false,
            MFJF: false
          },
          tinNumber: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              required: this.errorMessages.default_required,
            },
            MF: true,
            JF: false,
            MFJF: true
          }
        },
        getForwardRoute: (investor?: Investor) => {
          investor = investor || this.investor;
          if (investor && investor.id) {
            return this.getForwardRoute(investor, this.businessUnit);
          }
        },
        getBackwardRoute: () => {
        }
      },
      'ipv-details': {
        inputs: {
          ipvFile: {
            validations: [],
            error: {
              'required': 'Please Click Valid IPV File.',
              'fileType': this.errorMessages.default_fileType2,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: true,
            MF: true,
            MFJF: true
          }
        },
        getForwardRoute: (investor?: Investor) => {
          investor = investor || this.investor;
          if (investor && investor.id) {
            return this.getForwardRoute(investor, this.businessUnit);
          }
        },
        getBackwardRoute: () => {
        }
      },
      'segment-details': {
        inputs: {
          segments: [
            {
              formControlName: 'NSECASH',
              formControlLabel: 'NSE CASH',
              id: '8a82b2b068bc46360168bc52702b0002',
              segmentName: "NSECash",
              segmentType: "Equity",
              validations: [],
              JF: true,
              MFJF: true
            },
            {
              formControlName: 'BSECash',
              formControlLabel: 'BSE CASH',
              id: '8a82b2b068bc46360168bc5271d80003',
              segmentName: "BSECash",
              segmentType: "Equity",
              validations: [],
              JF: true,
              MFJF: true
            },
            {
              formControlName: 'NSEFNO',
              formControlLabel: 'NSE F&O',
              id: '8a82b2b0689dbae201689dbb581e0001',
              segmentName: "NSEFNO",
              segmentType: "Derivatives",
              validations: [],
              JF: true,
              MFJF: true
            },
            {
              formControlName: 'BSEFNO',
              formControlLabel: 'BSE F&O',
              id: '8a82b2b068bc46360168bc5272fe0006',
              segmentName: "BSEFNO",
              segmentType: "Derivatives",
              validations: [],
              JF: true,
              MFJF: true,
              hidden: true
            },
            {
              formControlName: 'NSECDS',
              formControlLabel: 'NSE CURRENCY',
              id: '8a82b2b068bc46360168bc5272320004',
              segmentName: "NSECDS",
              segmentType: "Equity",
              validations: [],
              JF: true,
              MFJF: true
            },
            {
              formControlName: 'BSECDS',
              formControlLabel: 'BSE CURRENCY',
              id: '8a82b2b068bc46360168bc52729b0005',
              segmentName: "BSECDS",
              segmentType: "Equity",
              validations: [],
              JF: true,
              MFJF: true,
              hidden: true
            },
            {
              formControlName: 'MCX',
              formControlLabel: 'MCX',
              id: '8a82b2b068bc46360168bc526e3c0000',
              segmentName: "MCX",
              segmentType: "Commodity",
              validations: [],
              JF: true,
              MFJF: true
            },
            {
              formControlName: 'NCDEX',
              formControlLabel: 'NCDEX',
              id: '8a82b2b068bc46360168bc526f570001',
              segmentName: "NCDEX",
              segmentType: "Commodity",
              validations: [],
              JF: true,
              MFJF: true
            }
            // {
            //   formControlName: 'ICEX',
            //   formControlLabel: 'ICEX',
            //   id: '8a82b2b069c40ced0169c43dd5480009',
            //   segmentName: "ICEX",
            //   segmentType: "Commodity",
            //   validations: [],
            //   JF: true,
            //   MFJF: true
            // }
            // {
            //   formControlName: 'MTF',
            //   formControlLabel: 'MTF(Margin Trading Facility)',
            //   id: 'ff8081816cdd312b016cdd34f0510000',
            //   segmentName: "MTF",
            //   segmentType: "Service",
            //   info: 'Using Margin Trading Facility (MTF) facility, an investor can buy Share saying a small amount from his available funds/shares as collateral known as Margin. The remaining balance required to complete the transaction is funded by the Bro. For more info <a href="https://choicebroking.in/mtf-services" target="_blank">Click Here</a>.',
            //   validations: [],
            //   JF: true,
            //   MFJF: true
            // }
          ],
          plans: {
            selected: 'Annual AMC Plan',
            disabled: true,
            controls: [
              { id: 'Annual AMC Plan', value: 'Annual AMC Plan', desc: '<strong>&#8377;  200+18% GST </strong><span class="info-style">(Free for 1st Year)</span>' },
              { id: 'Life Time AMC Plan', value: 'Life Time AMC Plan', desc: '<strong>&#8377; 1,500 + 18% GST</strong>' },
              { id: 'Zero AMC Plan', value: 'Zero AMC Plan', desc: 'NIL with <strong>&#8377; 3,000 Refundable Deposit</strong>. Deposit will be refunded at the time of closing of Demat Account.' },
              {id:'First Three Years AMC Free Plan' ,value:'First Three Years AMC Free Plan',desc:''},
              {id:'BSDA',value:'BSDA',desc:''}
            ],
            validations: [],
            JF: true,
            MFJF: true
          }
        },
        getForwardRoute: (investor?: Investor) => {
          investor = investor || this.investor;
          if (investor && investor.id) {
            return this.getForwardRoute(investor, this.businessUnit);
          }
        },
        getBackwardRoute: () => {
        }
      },
      'document-uploads': {
        inputs: {
          panCardFile: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              'required': this.errorMessages.panFile_required,
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          photoFile: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              'required': this.errorMessages.photoFile_required,
              'fileType': this.errorMessages.default_fileType2,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          addrProofType: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              'required': this.errorMessages.incProof_required,
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          addrProofFrontFile: {
            JFValidators: [Validators.required],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              'required': 'Please Click/Upload Valid Address Proof.',
              'fileType': 'Please upload file having extensions jpeg, jpg, and png only.',
              'fileTypeadhaar': 'Please upload file having extensions jpeg, jpg and png only.',
              'fileSize': 'Maximum Allowed File size is 10MB.',
              'fileSize2': 'Maximum Allowed File size is 10MB.',
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          ismaskingadhaar:{
            JFValidators: [Validators.required],
            MFJFValidators: [Validators.required],
            MFValidators: [Validators.required],
            JF: true,
            MF: true,
            MFJF: true,
          },
          addrProofRearFile: {
            validations: [],
            error: {
              'required': 'Please Click/Upload Valid Address Proof.',
              'fileType': 'Please upload file having extensions jpeg, jpg, and png only.',
              'fileSize': 'Maximum Allowed File size is 10MB.',
              'fileSize2': 'Maximum Allowed File size is 10MB.',
              'fileTypeadhaar': 'Please upload file having extensions jpeg, jpg and png only.',
            },
            JF: true,
            MF: true,
            MFJF: true,
            hidden: true
          },
          overseasAddressFrontFile: {
            JFValidators: [Validators.required],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              'required': this.errorMessages.overseasAddProof_required,
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: false,
            MF: true,
            MFJF: false
          },
          overseasAddressRearFile: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              'required': this.errorMessages.overseasAddProof_required,
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: false,
            MF: true,
            MFJF: false
          },
          passportFrontFile: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              'required': this.errorMessages.passportFile_required,
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: false,
            MF: true,
            MFJF: false
          },
          passportRearFile: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              'required': this.errorMessages.passportFile_required,
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: false,
            MF: true,
            MFJF: false
          },
          visaFile: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              'required': 'Please Upload VISA.',
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: false,
            MF: true,
            MFJF: false
          },
          incomeProofType: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              'required': this.errorMessages.incProof_required,
            },
            JF: true,
            MF: false,
            MFJF: true
          },
          incomeProofFile: {
            validations: [],
            error: {
              'required': this.errorMessages.incProofFile_required,
              'fileType': this.errorMessages.default_fileType_incomeproof,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: true,
            MF: false,
            MFJF: true
          },
          plans: {
            selected: 'Annual AMC Plan',
            disabled: true,
            controls: [
              { id: 'Annual AMC Plan', value: 'Annual AMC Plan', desc: '<strong>&#8377;  200+18% GST </strong><span class="info-style">(Free for 1st Year)</span>', key: '3' },
              { id: 'Life Time AMC Plan', value: 'Life Time AMC Plan', desc: '<strong>&#8377; 1,500 + 18% GST</strong>', key: '1' },
              { id: 'Zero AMC Plan', value: 'Zero AMC Plan', desc: 'NIL with <strong>&#8377; 3,000 Refundable Deposit</strong>. Deposit will be refunded at the time of closing of Demat Account.', key: '2' },
              {id:'First Three Years AMC Free Plan' ,value:'First Three Years AMC Free Plan',desc:'',key:'4'},
              {id:'BSDA',value:'BSDA',desc:'',key:'5'}
            ],
            validations: [],
            JF: false,
            MFJF: false
          },
          signFile: {
            validations: [Validators.required],
            error: {
              'required': this.errorMessages.signFile_required,
              'fileType': this.errorMessages.default_fileType2,
              'fileSize': this.errorMessages.default_fileSize3
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          expireDate: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.expire_date,
              pattern: this.errorMessages.invalidFormat
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          
          identifyNumber: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.identify_Number,
            },
            MF: true,
            JF: true,
            MFJF: true
          },

          segments: [
            {
              formControlName: 'MTF',
              formControlLabel: 'MTF(Margin Trading Facility)',
              id: 'ff8081816cdd312b016cdd34f0510000',
              info: 'Using Margin Trading Facility (MTF) facility, an investor can buy shares using a small amount from his available funds/shares as collateral known as margin. The remaining balance required to complete the transaction is funded by the broker.',
              segmentName: "MTF",
              segmentType: "Service",
              incomeProofRequired: false,
              validations: [],
              hidden: false,
              JF: true,
              MFJF: true
            },
            {
              formControlName: 'NSESLBM',
              formControlLabel: 'SLBM (NSE)',
              id: '9481b24273c8d3ad0173cca5cd240000',
              info: 'SLBM or Stock Lending and Borrowing is a mechanism in which a trader can borrow shares that they do not already own or can lend the stocks that they own. An SLBM transaction has a rate of interest and a fixed tenure.',
              segmentName: "NSESLBM",
              segmentType: "Service",
              incomeProofRequired: false,
              validations: [],
              JF: true,
              MFJF: true
            },{
              formControlName: 'BSECDS',
              formControlLabel: 'CURRENCY',
              info: 'Currency derivatives are financial contracts between the buyer and seller involving the exchange of two currencies at a future.',
              id: '8a82b2b068bc46360168bc52729b0005',
              segmentName: "BSECDS",
              segmentType: "Currency",
              validations: [],
              JF: true,
              MFJF: true,
              hidden: true
            },
            {
              formControlName: 'MCX',
              formControlLabel: 'MCX',
              info: 'In the commodity market, you can buy, sell, or trade raw products like oil, gold, copper or coffee, categorized as either natural resources (hard commodities) or livestock and agricultural goods (soft commodities).',
              id: '8a82b2b068bc46360168bc526e3c0000',
              segmentName: "MCX",
              segmentType: "Commodity",
              validations: [],
              JF: true,
              MFJF: true
            },
            {
              formControlName: 'BSEFNO',
              formControlLabel: 'DERIVATIVES',
              info: 'Equity derivatives are contracts deriving value from stock or stock index price movements, such as Nifty 50 and Bank Nifty.',
              id: '8a82b2b068bc46360168bc5272fe0006',
              segmentName: "BSEFNO",
              segmentType: "Equity",
              validations: [],
              JF: true,
              MFJF: true,
              hidden: true
            },


          ]

          
        },
        getForwardRoute: (investor?: Investor, isSkippable?) => {
          investor = investor || this.investor;
          if (investor && investor.id) {
            return this.getForwardRoute(investor, this.businessUnit, isSkippable);
          }
        },
        getBackwardRoute: () => {
        }
      },
      'brokerage-details': {
        inputs: {
          eqTrPaisa1: {
            validations: [Validators.required],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': this.errorMessages.brokerage_min
            },
          },
          eqTrPer1: {
            validations: [Validators.required],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': this.errorMessages.eqt_min
            },
          },
          eqTrPaisa2: {
            validations: [Validators.required],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': this.errorMessages.brokerage_min
            },
          },
          eqTrPer2: {
            validations: [Validators.required],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': this.errorMessages.eqt_min
            },
          },
          eqDelPaisa1: {
            validations: [Validators.required],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': this.errorMessages.brokerage_min
            },
          },
          eqDelPer1: {
            validations: [Validators.required],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': this.errorMessages.eqt_min
            },
          },
          eqDelPaisa2: {
            validations: [Validators.required],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': this.errorMessages.brokerage_min
            },
          },
          eqDelPer2: {
            validations: [Validators.required],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': this.errorMessages.eqt_min
            },
          },
          eqFutPaisa1: {
            validations: [Validators.required],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': this.errorMessages.brokerage_min
            },
          },
          eqFutPer1: {
            validations: [Validators.required],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': this.errorMessages.eqt_min
            },
          },
          eqFutPaisa2: {
            validations: [Validators.required],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': this.errorMessages.brokerage_min
            },
          },
          eqFutPer2: {
            validations: [Validators.required],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': this.errorMessages.eqt_min
            },
          },
          eqOptionRs1: {
            validations: [Validators.required],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': 'Min value allowed is Re. 1.'
            },
          },
          eqOptionRs2: {
            validations: [Validators.required],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': 'Min value allowed is is Re. 1.'
            },
          },
          cdFutPaisa1: {
            validations: [Validators.required],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': this.errorMessages.brokerage_min
            },
          },
          cdFutPer1: {
            validations: [Validators.required],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': this.errorMessages.eqt_min
            },
          },
          cdFutPaisa2: {
            validations: [Validators.required],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': this.errorMessages.brokerage_min
            },
          },
          cdFutPer2: {
            validations: [Validators.required],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': this.errorMessages.eqt_min
            },
          },
          cdOptionRs1: {
            validations: [Validators.required],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': 'Min value allowed is Re. 1.'
            },
          },
          cdOptionRs2: {
            validations: [Validators.required],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': 'Min value allowed is is Re. 1.'
            },
          },
          commFutPaisa1: {
            validations: [Validators.required],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': this.errorMessages.brokerage_min
            },
          },
          commFutPer1: {
            validations: [Validators.required],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': this.errorMessages.eqt_min
            },
          },
          commFutPaisa2: {
            validations: [Validators.required],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': this.errorMessages.brokerage_min
            },
          },
          commFutPer2: {
            validations: [Validators.required],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': this.errorMessages.eqt_min
            },
          },
          commOptionRs1: {
            validations: [Validators.required],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': 'Min value allowed is Re. 1.'
            },
          },
          commOptionRs2: {
            validations: [Validators.required],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': 'Min value allowed is is Re. 1.'
            },
          },
          niftyFutPaisa1: {
            validations: [],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': this.errorMessages.brokerage_min
            },
          },
          niftyFutPer1: {
            validations: [],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': this.errorMessages.eqt_min
            },
          },
          niftyFutPaisa2: {
            validations: [],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': this.errorMessages.brokerage_min
            },
          },
          niftyFutPer2: {
            validations: [],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': this.errorMessages.eqt_min
            },
          },
          niftyOptionRs1: {
            validations: [],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': 'Min value allowed is Re. 1.'
            },
          },
          niftyOptionRs2: {
            validations: [],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': 'Min value allowed is is Re. 1.'
            },
          },
          bankNiftyFutPaisa1: {
            validations: [],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': this.errorMessages.brokerage_min
            },
          },
          bankNiftyFutPer1: {
            validations: [],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': this.errorMessages.eqt_min
            },
          },
          bankNiftyFutPaisa2: {
            validations: [],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': this.errorMessages.brokerage_min
            },
          },
          bankNiftyFutPer2: {
            validations: [],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': this.errorMessages.eqt_min
            },
          },
          bankNiftyOptionRs1: {
            validations: [],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': 'Min value allowed is Re. 1.'
            },
          },
          bankNiftyOptionRs2: {
            validations: [],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': 'Min value allowed is is Re. 1.'
            },
          },
          goldFutPaisa1: {
            validations: [],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': this.errorMessages.brokerage_min
            },
          },
          goldFutPer1: {
            validations: [],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': this.errorMessages.eqt_min
            },
          },
          goldFutPaisa2: {
            validations: [],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': this.errorMessages.brokerage_min
            },
          },
          goldFutPer2: {
            validations: [],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': this.errorMessages.eqt_min
            },
          },
          goldOptionRs1: {
            validations: [],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': 'Min value allowed is Re. 1.'
            },
          },
          goldOptionRs2: {
            validations: [],
            JF: true,
            error: {
              'required': this.errorMessages.default_required,
              'min': 'Min value allowed is is Re. 1.'
            },
          },
          remark: {
            validations: [Validators.maxLength(255)],
            JF: true
          }
        },
        getForwardRoute: (investor?: Investor) => {
          investor = investor || this.investor;
          if (investor && investor.id) {
            return this.getForwardRoute(investor, this.businessUnit);
          }
        },
        getBackwardRoute: () => {
        }
      },
      'esign': {
        esignURL: '',
        successURL: '/succRes.jsp',
        failureURL: '/failRes.jsp',
        getForwardRoute: (investor?: Investor) => {
          investor = investor || this.investor;
          if (investor && investor.id) {
            return this.getForwardRoute(investor, this.businessUnit);
          }
        },
        getBackwardRoute: () => {
        }
      },
      'support': {
        inputs: {
          name: {
            validations: [Validators.required, Validators.pattern(nameRegex)],
            error: {
              required: this.errorMessages.defaultName_required,
              pattern: this.errorMessages.name_invalid
            },
            JF: true,
            MF: true
          },
          email: {
            validations: [Validators.required, Validators.pattern(emailRegex)],
            error: {
              required: this.errorMessages.email_required,
              pattern: this.errorMessages.email_invalid
            },
            JF: true,
            MF: true
          },
          subject: {
            JFValidators: [Validators.required],
            MFValidators: [Validators.required],
            error: {
              required: this.errorMessages.defaultSubject_required
            },
            JF: true,
            MF: false
          },
          message: {
            validations: [Validators.required, Validators.maxLength(250), Validators.pattern(messageRegex)],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.defaultInvalid_msg
            },
            JF: true,
            MF: true
          }
        }
      },
      'client-login': {
        inputs: {
          clientId: {
            validations: [Validators.maxLength(20), Validators.pattern(userNameRegex)],
            error: {
              required: this.errorMessages.clientId_required,
              pattern: this.errorMessages.clientId_pattern,
              maxlength: this.errorMessages.clientID_maxlength,
            },
            JF: true,
            MF: true
          },
          panNumber: {
            validations: [Validators.minLength(10), Validators.maxLength(10), Validators.pattern(panNumberRegex)],
            error: {
              required: this.errorMessages.pan_required,
              pattern: this.errorMessages.pan_pattern
            },
            MF: true,
            JF: true
          },
          otp: {
            validations: [Validators.required, Validators.pattern(unifiedotpRegex)],
            error: {
              required: this.errorMessages.otp_required,
              pattern: this.errorMessages.unifiedotp_pattern
            },
            MF: true,
            JF: true
          },
          signFile: {
            validations: [],
            error: {
              'required': this.errorMessages.signFile_required,
              'fileType': this.errorMessages.default_fileType2,
              'fileSize': this.errorMessages.default_fileSize3
            },
            JF: true
          }
        }
      },
      'client-modification': {
        inputs: {
          segments: [
            {
              formControlName: 'CASH',
              formControlLabel: 'CASH (NSE & BSE)',
              id: '8a82b2b068bc46360168bc52702b0002',
              segmentName: "NSECash",
              segmentType: "Cash",
              validations: [],
              incomeProofRequired: false,
              JF: true,
              MFJF: true
            },

            {
              formControlName: 'FO',
              formControlLabel: 'EQUITY F&O (NSE & BSE)',
              id: '8a82b2b068bc46360168bc52702b0002',
              segmentName: "NSECash",
              segmentType: "FNO",
              validations: [],
              incomeProofRequired: true,
              JF: true,
              MFJF: true
            },
            {
              formControlName: 'CURRENCY',
              formControlLabel: 'CURRENCY (NSE & BSE) ',
              id: '8a82b2b068bc46360168bc5271d80003',
              segmentName: "BSECash",
              segmentType: "Currency",
              incomeProofRequired: true,
              validations: [],
              JF: true,
              MFJF: true
            },
            {
              formControlName: 'COMMODITY',
              formControlLabel: 'COMMODITY (MCX, NCDEX & NSE)',
              id: '8a82b2b0689dbae201689dbb581e0001',
              segmentName: "NSEFNO",
              segmentType: "Commodity",
              incomeProofRequired: true,
              validations: [],
              JF: true,
              MFJF: true
            },

            // {
            //   formControlName: 'DEBT',
            //   formControlLabel: 'DEBT (NSE & BSE)',
            //   id: '8a82b2b068bc46360168bc5272fe0006',
            //   segmentName: "BSEFNO",
            //   segmentType: "Debt",
            //   incomeProofRequired: false,
            //   validations: [],
            //   JF: true,
            //   MFJF: true,
            // },
            {
              formControlName: 'MTF',
              formControlLabel: 'MTF(Margin Trading Facility)',
              id: 'ff8081816cdd312b016cdd34f0510000',
              info: 'Using Margin Trading Facility (MTF) facility, an investor can buy shares using a small amount from his available funds/shares as collateral known as margin. The remaining balance required to complete the transaction is funded by the broker.',
              segmentName: "MTF",
              segmentType: "MTF",
              incomeProofRequired: false,
              validations: [],
              JF: true,
              MFJF: true
            },
            {
              formControlName: 'SLBM',
              formControlLabel: 'SLBM',
              id: '9481b24273c8d3ad0173cca5cd240000',
              info: 'SLBM or stock lending and borrowing is a mechanism in which a trader can borrow shares that they do not already own or can lend the stocks that they own. An SLBM transaction has a rate of interest and a fixed tenure.',
              segmentName: "NSESLBM",
              segmentType: "SLBM",
              incomeProofRequired: false,
              validations: [],
              JF: true,
              MFJF: true
            },

            // {
            //   formControlName: 'NSECASH',
            //   formControlLabel: 'NSE CASH',
            //   id: '8a82b2b068bc46360168bc52702b0002',
            //   segmentName: "NSECash",
            //   segmentType: "Equity",
            //   validations: [],
            //   incomeProofRequired: false,
            //   JF: true,
            //   MFJF: true
            // },
            // {
            //   formControlName: 'BSECash',
            //   formControlLabel: 'BSE CASH',
            //   id: '8a82b2b068bc46360168bc5271d80003',
            //   segmentName: "BSECash",
            //   segmentType: "Equity",
            //   incomeProofRequired: false,
            //   validations: [],
            //   JF: true,
            //   MFJF: true
            // },
            // {
            //   formControlName: 'NSEFNO',
            //   formControlLabel: 'NSE F&O',
            //   id: '8a82b2b0689dbae201689dbb581e0001',
            //   segmentName: "NSEFNO",
            //   segmentType: "Derivatives",
            //   incomeProofRequired: true,
            //   validations: [],
            //   JF: true,
            //   MFJF: true
            // },
            // {
            //   formControlName: 'NSESLBM',
            //   formControlLabel: 'NSE-SLBM',
            //   id: '9481b24273c8d3ad0173cca5cd240000',
            //   info: 'SLB or stock lending and borrowing is a mechanism in which a trader can borrow shares that they do not already own or can lend the stocks that they own. An SLB transaction has a rate of interest and a fixed tenure.',
            //   segmentName: "NSESLBM",
            //   segmentType: "Service",
            //   incomeProofRequired: false,
            //   validations: [],
            //   JF: true,
            //   MFJF: true
            // },
            // {
            //   formControlName: 'BSEFNO',
            //   formControlLabel: 'BSE F&O',
            //   id: '8a82b2b068bc46360168bc5272fe0006',
            //   segmentName: "BSEFNO",
            //   segmentType: "Derivatives",
            //   incomeProofRequired: true,
            //   validations: [],
            //   JF: true,
            //   MFJF: true,
            //   hidden: true
            // },
            // {
            //   formControlName: 'NSECDS',
            //   formControlLabel: 'NSE CURRENCY',
            //   id: '8a82b2b068bc46360168bc5272320004',
            //   segmentName: "NSECDS",
            //   segmentType: "Equity",
            //   incomeProofRequired: true,
            //   validations: [],
            //   JF: true,
            //   MFJF: true
            // },
            // {
            //   formControlName: 'BSECDS',
            //   formControlLabel: 'BSE CURRENCY',
            //   id: '8a82b2b068bc46360168bc52729b0005',
            //   segmentName: "BSECDS",
            //   segmentType: "Equity",
            //   incomeProofRequired: true,
            //   validations: [],
            //   JF: true,
            //   MFJF: true,
            //   hidden: true,
            // },
            // {
            //   formControlName: 'MCX',
            //   formControlLabel: 'MCX',
            //   id: '8a82b2b068bc46360168bc526e3c0000',
            //   segmentName: "MCX",
            //   segmentType: "Commodity",
            //   incomeProofRequired: true,
            //   validations: [],
            //   JF: true,
            //   MFJF: true
            // },
            // {
            //   formControlName: 'NCDEX',
            //   formControlLabel: 'NCDEX',
            //   id: '8a82b2b068bc46360168bc526f570001',
            //   segmentName: "NCDEX",
            //   segmentType: "Commodity",
            //   incomeProofRequired: true,
            //   validations: [],
            //   JF: true,
            //   MFJF: true
            // },
            // {
            //   formControlName: 'ICEX',
            //   formControlLabel: 'ICEX',
            //   id: '8a82b2b069c40ced0169c43dd5480009',
            //   segmentName: "ICEX",
            //   segmentType: "Commodity",
            //   incomeProofRequired: true,
            //   validations: [],
            //   hidden: true,
            //   JF: true,
            //   MFJF: true
            // },
            // {
            //   formControlName: 'MTF',
            //   formControlLabel: 'MTF(Margin Trading Facility)',
            //   id: 'ff8081816cdd312b016cdd34f0510000',
            //   info: 'Using Margin Trading Facility (MTF) facility, an investor can buy shares using a small amount from his available funds/shares as collateral known as margin. The remaining balance required to complete the transaction is funded by the broker. For more info <a href="https://choiceindia.com/margin-trading-facility-mtf" target="_blank">Click Here</a>.',
            //   segmentName: "MTF",
            //   segmentType: "Service",
            //   incomeProofRequired: false,
            //   validations: [],
            //   hidden: false,
            //   JF: true,
            //   MFJF: true
            // }
          ],
          incomeProofType: {
            validations: [],
            error: {
              'required': this.errorMessages.incProof_required,
            },
            JF: true,
            MFJF: true
          },
          incomeProofFile: {
            validations: [],
            error: {
              'required': this.errorMessages.incProofFile_required,
              'fileType': this.errorMessages.default_fileType_incomeproof,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: true,
            MFJF: true
          },
          mobileNumber: {
            validations: [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
            error: {
              required: this.errorMessages.mob_required,
              pattern: this.errorMessages.mob_pattern
            },
            MF: true,
            JF: true,
          },
          // Validators.required, Validators.minLength(2)
          address: {
            validations: [],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid,
              minLength: this.errorMessages.address_invalid
            },
            JF: false,
            MF: true,
            MFJF: true
          },
          address1: {
            validations: [Validators.required, Validators.minLength(2)],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid,
              minLength: this.errorMessages.address_invalid
            },
            JF: true,
            MF: false,
            MFJF: false
          },
          // , Validators.minLength(2)
          address2: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid,
              minLength: this.errorMessages.address_invalid
            },
            JF: true,
            MF: false,
            MFJF: false
          },
          city: {
            validations: [Validators.required, Validators.minLength(2)],//, Validators.pattern(cityRegex)
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.city_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          state: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.state_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          zipCode: {
            validations: [Validators.required, Validators.pattern(pinCodeRegex)],
            error: {
              required: this.errorMessages.zipcode_required,
              pattern: this.errorMessages.zipcode_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          isAddressSame: {
            JFValidators: [],
            MFJFValidators: [],
            JF: true,
            MF: false,
            MFJF: true
          },
          //           Validators.minLength(2)
          //           Validators.minLength(2)
          addressC: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid,
              minLength: this.errorMessages.address_invalid
            },
            JF: false,
            MFJF: true
          },
          addressC1: {
            JFValidators: [Validators.minLength(2)],
            MFJFValidators: [Validators.minLength(2)],
            MFValidators: [],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid,
              minLength: this.errorMessages.address_invalid
            },
            JF: true,
            MFJF: false
          },
          //           Validators.minLength(2)
          //           Validators.minLength(2)
          addressC2: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid,
              minLength: this.errorMessages.address_invalid
            },
            JF: true,
            MFJF: false
          },
          cityC: {
            JFValidators: [Validators.minLength(2)],//, Validators.pattern(cityRegex)
            MFValidators: [],
            MFJFValidators: [Validators.minLength(2)],//, Validators.pattern(cityRegex)
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: true,
            MFJF: false
          },
          stateC: {
            JFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
            MFJFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
            MFValidators: [],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: true,
            MFJF: true
          },
          zipCodeC: {
            JFValidators: [Validators.pattern(pinCodeRegex)],
            MFJFValidators: [Validators.pattern(pinCodeRegex)],
            MFValidators: [],
            error: {
              required: this.errorMessages.zipcode_required,
              pattern: this.errorMessages.zipcode_invalid
            },
            JF: true,
            MFJF: true
          },
          addrProofType: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              'required': this.errorMessages.incProof_required,
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          addrProofFrontFile: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              'required': 'Please Click/Upload Valid Address Proof.',
              'fileType': 'Please upload file having extensions jpeg, jpg, and png only.',
              'fileSize': 'Maximum Allowed File size is 10MB.',
              'fileSize2': 'Maximum Allowed File size is 2MB.',
              'fileTypeadhaar': 'Please upload file having extensions jpeg, jpg and png only.'
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          selfiePhotoFileName: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              'required': 'Need to add selfie.',
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          addrProofRearFile: {
            validations: [],
            error: {
              'required': 'Please Click/Upload Valid Address Proof.',
              'fileType': 'Please upload file having extensions jpeg, jpg, and png only.',
              'fileSize': 'Maximum Allowed File size is 10MB.',
              'fileSize2': 'Maximum Allowed File size is 2MB.',
              'fileTypeadhaar': 'Please upload file having extensions jpeg, jpg and png only.'
            },
            JF: true,
            MF: true,
            MFJF: true,
            hidden: true
          },

          ismaskingadhaar:{
            JFValidators: [Validators.required],
            MFJFValidators: [Validators.required],
            MFValidators: [Validators.required],
            JF: true,
            MF: true,
            MFJF: true,
          },
          addrCProofType: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              'required': this.errorMessages.incProof_required,
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          addrCProofFrontFile: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              'required': this.errorMessages.validAddProof_required,
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          addrCProofRearFile: {
            validations: [],
            error: {
              'required': this.errorMessages.validAddProof_required,
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: true,
            MF: true,
            MFJF: true,
            hidden: true
          },
          email: {
            validations: [Validators.required, Validators.pattern(emailRegex)],
            error: {
              required: this.errorMessages.email_required,
              pattern: this.errorMessages.email_invalid
            },
            JF: true,
            MF: true
          },
          mobOtp: {
            validations: [Validators.maxLength(6),Validators.pattern(unifiedotpRegex)],
            error: {
              required: this.errorMessages.otp_required,
              pattern: this.errorMessages.unifiedotp_pattern,
              maxlength: this.errorMessages.clientID_maxlength,
            },
            MF: true,
            JF: true
          },
          emailOtp: {
            validations: [Validators.pattern(unifiedotpRegex)],
            error: {
              required: this.errorMessages.otp_required,
              pattern: this.errorMessages.unifiedotp_pattern
            },
            MF: true,
            JF: true
          },
        }
      },
      'add-bank-details': {
        inputs: {
          chequeFile: {
            validations: [Validators.required],
            error: {
              'required': this.errorMessages.cheque_required,
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          accountNumber: {
            validations: [Validators.required, Validators.pattern(accNoRegex)],
            error: {
              required: this.errorMessages.accNo_required,
              pattern: this.errorMessages.accNo_pattern
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          repeatAccountNumber: {
            validations: [Validators.required, Validators.pattern(accNoRegex)],
            error: {
              required: this.errorMessages.accNo_required,
              pattern: this.errorMessages.accNo_pattern,
              invalid: this.errorMessages.accNo_notmatch
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          ifsc: {
            validations: [Validators.required, Validators.pattern(ifscRegex)],
            error: {
              required: this.errorMessages.ifsc_required,
              pattern: this.errorMessages.ifsc_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          bankName: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.bankname_required
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          branch: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.bankbranchname_required
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          bankAddress: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.branchAdd_required
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          micr: {
            validations: [],
            JF: true,
            MF: true,
            MFJF: true
          },
          bankZipCode: {
            JFValidators: [Validators.pattern(pinCodeRegex)],
            MFJFValidators: [Validators.required, Validators.pattern(pinCodeRegex)],
            MFValidators: [],
            error: {
              required: this.errorMessages.zipcode_required,
              pattern: this.errorMessages.zipcode_invalid
            },
            JF: true,
            MFJF: true
          },
          accountType: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.accType_required
            },
            defaults: { JF: 'S', MF: 'S', MFJF: 'S' },
            JF: true,
            MF: true,
            MFJF: true
          },
          addType: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.purpose_required
            },
            defaults: { JF: '1' },
            JF: true,
          }
        },
        getForwardRoute: (investor?: Investor) => {
          investor = investor || this.investor;
          if (investor && investor.id) {
            return this.getForwardRoute(investor, this.businessUnit);
          }
        },
        getBackwardRoute: () => {
        }
      },
      'respond-client-login': {
        inputs: {
          clientId: {
            validations: [Validators.maxLength(20), Validators.pattern(userNameRegex)],
            error: {
              required: this.errorMessages.clientId_required,
              pattern: this.errorMessages.clientId_pattern,
              maxlength: this.errorMessages.clientID_maxlength,
            },
            JF: true,
            MF: true
          },
          panNumber: {
            validations: [Validators.minLength(10), Validators.maxLength(10), Validators.pattern(panNumberRegex)],
            error: {
              required: this.errorMessages.pan_required,
              pattern: this.errorMessages.pan_pattern
            },
            MF: true,
            JF: true
          },
          otp: {
            validations: [Validators.required, Validators.pattern(unifiedotpRegex)],
            error: {
              required: this.errorMessages.otp_required,
              pattern: this.errorMessages.unifiedotp_pattern
            },
            MF: true,
            JF: true
          }
        }
      },
      'respond-issue': {
        inputs: {
          panCardFile: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              'required': this.errorMessages.panFile_required,
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          photoFile: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              'required': this.errorMessages.photoFile_required,
              'fileType': this.errorMessages.default_fileType2,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          signFile: {
            validations: [],
            error: {
              'required': this.errorMessages.signFile_required,
              'fileType': this.errorMessages.default_fileType2,
              'fileSize': this.errorMessages.default_fileSize3
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          addrProofType: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              'required': this.errorMessages.incProof_required,
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          addrProofFrontFile: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              'required': 'Please Click/Upload Valid Address Proof.',
              'fileType': 'Please upload file having extensions jpeg, jpg, and png only.',
              'fileSize': 'Maximum Allowed File size is 10MB.',
              'fileSize2': 'Maximum Allowed File size is 2MB.',
              'fileTypeadhaar': 'Please upload file having extensions jpeg, jpg and png only.'
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          addrProofRearFile: {
            validations: [],
            error: {
              'required': 'Please Click/Upload Valid Address Proof.',
              'fileType': 'Please upload file having extensions jpeg, jpg, and png only.',
              'fileSize': 'Maximum Allowed File size is 10MB.',
              'fileSize2': 'Maximum Allowed File size is 2MB.',
              'fileTypeadhaar': 'Please upload file having extensions jpeg, jpg and png only.',
            },
            JF: true,
            MF: true,
            MFJF: true,
            hidden: true
          },
          ismaskingadhaar:{
            JFValidators: [Validators.required],
            MFJFValidators: [Validators.required],
            MFValidators: [Validators.required],
            JF: true,
            MF: true,
            MFJF: true,
          },
          overseasAddressFrontFile: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              'required': 'Please Click/Upload Valid Overseas Address Proof.',
              'fileType': 'Please upload file having extensions jpeg, jpg, png only.',
              'fileSize': 'Maximum Allowed File size is 10MB.'
            },
            JF: false,
            MF: true,
            MFJF: false
          },
          overseasAddressRearFile: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              'required': this.errorMessages.overseasAddProof_required,
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: false,
            MF: true,
            MFJF: false
          },
          passportFrontFile: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              'required': this.errorMessages.passportFile_required,
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: false,
            MF: true,
            MFJF: false
          },
          passportRearFile: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              'required': this.errorMessages.passportFile_required,
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: false,
            MF: true,
            MFJF: false
          },
          visaFile: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              'required': 'Please Upload VISA.',
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: false,
            MF: true,
            MFJF: false
          },
          incomeProofType: {
            JFValidators: [],
            MFJFValidators: [],
            MFValidators: [],
            error: {
              'required': this.errorMessages.incProof_required,
            },
            JF: true,
            MF: false,
            MFJF: true
          },
          incomeProofFile: {
            validations: [],
            error: {
              'required': this.errorMessages.incProofFile_required,
              'fileType': this.errorMessages.default_fileType_incomeproof,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: true,
            MF: false,
            MFJF: true
          },
          ipvFile: {
            validations: [],
            error: {
              'required': this.errorMessages.ipvFile_required,
              'fileType': this.errorMessages.default_fileType2,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          chequeFile: {
            validations: [],
            error: {
              'required': this.errorMessages.cheque_required,
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          accountNumber: {
            validations: [Validators.pattern(accNoRegex)],
            error: {
              required: this.errorMessages.accNo_required,
              pattern: this.errorMessages.accNo_pattern
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          repeatAccountNumber: {
            validations: [Validators.pattern(accNoRegex)],
            error: {
              required: this.errorMessages.accNo_required,
              pattern: this.errorMessages.accNo_pattern,
              invalid: this.errorMessages.accNo_notmatch
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          ifsc: {
            validations: [Validators.pattern(ifscRegex)],
            error: {
              required: this.errorMessages.ifsc_required,
              pattern: this.errorMessages.ifsc_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          bankName: {
            validations: [],
            error: {
              required: this.errorMessages.bankname_required
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          branch: {
            validations: [],
            error: {
              required: this.errorMessages.bankbranchname_required
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          bankAddress: {
            validations: [],
            error: {
              required: this.errorMessages.branchAdd_required
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          micr: {
            validations: [],
            JF: true,
            MF: true,
            MFJF: true
          },
          bankZipCode: {
            JFValidators: [Validators.pattern(pinCodeRegex)],
            MFJFValidators: [Validators.required, Validators.pattern(pinCodeRegex)],
            MFValidators: [],
            error: {
              required: this.errorMessages.zipcode_required,
              pattern: this.errorMessages.zipcode_invalid
            },
            JF: true,
            MFJF: true
          },
          accountType: {
            validations: [],
            error: {
              required: this.errorMessages.accType_required
            },
            defaults: { JF: 'S', MF: 'S', MFJF: 'S' },
            JF: true,
            MF: true,
            MFJF: true
          },
          address: {
            // , Validators.pattern(addressRegex)
            validations: [Validators.required, Validators.minLength(2)],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: false,
            MF: true,
            MFJF: true
          },
          address1: {
            validations: [Validators.required, Validators.minLength(2)],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: true,
            MF: false,
            MFJF: false
          },
          address2: {
            validations: [Validators.required, Validators.minLength(2)],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: true,
            MF: false,
            MFJF: false
          },
          city: {
            validations: [Validators.required, Validators.minLength(2), Validators.pattern(cityRegex)],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.city_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          state: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.state_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          zipCode: {
            validations: [Validators.required, Validators.pattern(pinCodeRegex)],
            error: {
              required: this.errorMessages.zipcode_required,
              pattern: this.errorMessages.zipcode_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          isAddressSame: {
            JFValidators: [Validators.required],
            MFJFValidators: [Validators.required],
            JF: true,
            MF: false,
            MFJF: true
          },
          addressC: {
            JFValidators: [Validators.minLength(2)],
            MFJFValidators: [Validators.minLength(2)],
            MFValidators: [],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: false,
            MFJF: true
          },
          addressC1: {
            JFValidators: [Validators.minLength(2)],
            MFJFValidators: [Validators.minLength(2)],
            MFValidators: [],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: true,
            MFJF: false
          },
          addressC2: {
            JFValidators: [Validators.minLength(2)],
            MFJFValidators: [Validators.minLength(2)],
            MFValidators: [],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: true,
            MFJF: false
          },
          cityC: {
            JFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
            MFValidators: [],
            MFJFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: true,
            MFJF: true
          },
          stateC: {
            JFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
            MFJFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
            MFValidators: [],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: true,
            MFJF: true
          },
          zipCodeC: {
            JFValidators: [Validators.pattern(pinCodeRegex)],
            MFJFValidators: [Validators.pattern(pinCodeRegex)],
            MFValidators: [],
            error: {
              required: this.errorMessages.zipcode_required,
              pattern: this.errorMessages.zipcode_invalid
            },
            JF: true,
            MFJF: true
          }
        }
      },
      'bank-bazaar-doc-upload': {
        inputs: {
          signFile: {
            validations: [],
            error: {
              'required': this.errorMessages.signUpload2,
              'fileType': this.errorMessages.default_fileType2,
              'fileSize': this.errorMessages.default_fileSize3
            },
            JF: false,
            MF: true,
            MFJF: false
          },
          chequeFile: {
            validations: [],
            error: {
              'required': this.errorMessages.chequeUpload2,
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            MF: true,
            JF: false,
            MFJF: false
          },
        }
      },
      'add-nominee-details': {
        inputs: {
          name: {
            validations: [Validators.required, Validators.minLength(2), Validators.pattern(nameRegex)],
            error: {
              required: this.errorMessages.nominee_required,
              pattern: this.errorMessages.name_invalid,
              sameName:this.errorMessages.nominee_same,
              duplicte_nomineeName: this.errorMessages.duplicte_nomineeName
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          mobileNum: {
            validations: [Validators.required,Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
            error: {
              required: this.errorMessages.mob_required,
              pattern: this.errorMessages.mob_pattern
            },
            MF: true,
            JF: true,
            MFJF: true,
          },
          email: {
            validations: [Validators.required,Validators.pattern(emailRegex)],
            error: {
              required: this.errorMessages.email_required,
              pattern: this.errorMessages.email_invalid
            },
            JF: true,
            MFJF: true
          },
          dob: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.dob_required,
              range: this.errorMessages.dob_range,
              pattern: this.errorMessages.invalidFormat
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          isMinor: {
            validations: [],
            error: {
              required: this.errorMessages.dob_required
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          isAddrSameAsApplicant: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.default_required
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          address: {
            validations: [],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: false,
            MF: false,
            MFJF: false
          },
          address1: {
            validations: [Validators.required, Validators.minLength(2)],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          address2: {
            validations: [Validators.required, Validators.minLength(2)],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          city: {
            validations: [Validators.required, Validators.minLength(2), Validators.pattern(cityRegex)],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.city_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          state: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.state_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          zipCode: {
            validations: [Validators.required, Validators.pattern(pinCodeRegex)],
            error: {
              required: this.errorMessages.zipcode_required,
              pattern: this.errorMessages.zipcode_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          relation: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.nomineeRelation_required
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          shares: {
            validations: [Validators.required, Validators.pattern(sharePercentRegex)],
            error: {
              required: this.errorMessages.sharePrcnt_required,
              pattern: this.errorMessages.sharePrcnt_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          proofType: {
            validations: [Validators.required],
            error: {
              'required': this.errorMessages.doctype_required
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          documentId: {
            JFValidators: [Validators.required],
            MFValidators: [Validators.required],
            MFJFValidators: [Validators.required],
            error: {
              'required': this.errorMessages.docID_required,
              'pattern': this.errorMessages.docID_invalid,
              'duplicte_docId': this.errorMessages.duplicte_docId
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          proofFileName1: {
            validations: [Validators.required],
            error: {
              'required': this.errorMessages.defaultUpload_valid,
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          proofFileName2: {
            validations: [],
            error: {
              // 'required': this.errorMessages.defaultUpload_valid,
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          guardianName: {
            validations: [Validators.minLength(2), Validators.pattern(nameRegex)],
            error: {
              required: this.errorMessages.guardianname_required,
              pattern: this.errorMessages.guardianname_invalid
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          gdMobileNum: {
            validations: [Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
            error: {
              required: this.errorMessages.mob_required,
              pattern: this.errorMessages.mob_pattern
            },
            MF: true,
            JF: true,
            MFJF: true,
          },
          gdEmail: {
            validations: [Validators.pattern(emailRegex)],
            error: {
              required: this.errorMessages.email_required,
              pattern: this.errorMessages.email_invalid
            },
            JF: true,
            MFJF: true
          },
          gdisAddrSameAsApplicant: {
            validations: [Validators.required],
            error: {
              required: this.errorMessages.default_required
            },
            MF: true,
            JF: true,
            MFJF: true
          },
          gdAddress: {
            validations: [],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.guardianAdd_invalid
            },
            JF: true,
            MFJF: true
          },
          gdAddress1: {
            validations: [Validators.required, Validators.minLength(2)],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          gdAddress2: {
            validations: [Validators.required, Validators.minLength(2)],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          gdCity: {
            validations: [Validators.required, Validators.minLength(2), Validators.pattern(cityRegex)],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.city_invalid
            },
            JF: true,
            MFJF: true
          },
          gdState: {
            validations: [Validators.required, Validators.minLength(2), Validators.pattern(cityRegex)],
            error: {
              required: this.errorMessages.default_required,
              pattern: this.errorMessages.address_invalid
            },
            JF: true,
            MFJF: true
          },
          gdZipCode: {
            validations: [Validators.required, Validators.pattern(pinCodeRegex)],
            error: {
              required: this.errorMessages.zipcode_required,
              pattern: this.errorMessages.zipcode_invalid
            },
            JF: true,
            MFJF: true
          },
          gdRelation: {
            validations: [Validators.required],
            error: {
              'required': this.errorMessages.doctype_required
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          gdProofType: {
            // validations: [Validators.required],
            error: {
              'required': this.errorMessages.doctype_required
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          gdDocumentId: {
            // validations: [Validators.required],
            JFValidators: [],
            MFValidators: [],
            MFJFValidators: [],
            error: {
              // 'required': this.errorMessages.docID_required,
              'pattern': this.errorMessages.docID_invalid
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          gdproofFileName1: {
            // validations: [Validators.required],
            error: {
              // 'required': this.errorMessages.defaultUpload_valid,
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: true,
            MF: true,
            MFJF: true
          },
          gdproofFileName2: {
            validations: [],
            error: {
              // 'required': this.errorMessages.defaultUpload_valid,
              'fileType': this.errorMessages.default_fileType,
              'fileSize': this.errorMessages.default_fileSize
            },
            JF: true,
            MF: true,
            MFJF: true
          },
        },
        getForwardRoute: (investor?: Investor) => {
          investor = investor || this.investor;
          if (investor && investor.id) {
            return this.getForwardRoute(investor, this.businessUnit);
          }
        },
        getBackwardRoute: () => {
        }
      },
      'review': {
        inputs: {
          isDDPIOpted: {
            validations: [Validators.required],
            error: {
              required: 'Authorization is required',
            },
            JF: true
          }
        },
      }
    }
  }

  /**
   * Getting Routing information
   * @param route route path assign
   * @param key key as param assign 
   * @returns Complete routing url assign
   */
  getRouteInfo(route: string, key?: string) {
    // console.log('called')
    this.businessUnit = this.getBusinessUnit();
    return key ? this.utils[route][key] : this.utils[route];
  }

  /**
   * identify bussinee unit
   * @returns Bussinessunit
   */
  getBusinessUnit() {
    /**href to pathname changes for businessunit in header issues. */
    let href = location.pathname.toLowerCase();
    return href.indexOf('/mf/') > -1 || href.indexOf('/connect-mf/') > -1 ? 'MF' :
      href.indexOf('/trading/') > -1 || href.indexOf('/connect-trading/') > -1 ? 'JF' :
        href.indexOf('/mf-trading/') > -1 || href.indexOf('/connect-mf-trading/') > -1 ? 'MFJF' : 'MFJF';
  }

  /**
   * store business unit
   */
  setBusinessUnit() {
    this.businessUnit = this.getBusinessUnit();
  }

  /** fetch original source platform */
  getOriginalSource() {
    let investorAccount = ((this.investor.investorAccountDetailsDtoList || [])[0] || new InvestorAccount());
    let isAlphabee = (investorAccount.lmsLeadSource) ? investorAccount.lmsLeadSource.toLowerCase().indexOf('alphabee') > -1 : (investorAccount.originalSource) ? investorAccount.originalSource.toLowerCase().indexOf('alphabee') > -1 : ((this.getLMSData(this.businessUnit) || {}).leadSource || '').toLowerCase().indexOf('alphabee') > -1;
    let href = location.href.toLowerCase();
    return href.indexOf('/mf/') > -1 ? 'INVESTICA' : (href.indexOf('trading/offline-onboard') > -1 ? 'NEURON_JIFFY_OFFLINE' : (
      href.indexOf('/trading/') > -1 || href.indexOf('/mf-trading/') > -1 ? isAlphabee ? 'ALPHABEE' : 'JIFFY' :
        href.indexOf('/connect-') > -1 || href.indexOf('/connect-') > -1 ? 'CHOICE CONNECT' : 'INVESTICA'))
  }

  /** Get Investor DOB Range  */
  getInvestorDOBRange() {
    const date = new Date();
    date.setFullYear(date.getFullYear() - 18);
    return { min: '1899-12-31', max: date.toJSON().split('T')[0] };
  }
/** Get Nominee DOB Range */
  getNomineeDOBRange() {
    const date = new Date();
    date.setFullYear(date.getFullYear() - 18);
    return { min: date.toJSON().split('T')[0], max: new Date().toJSON().split('T')[0] };
  }
/**
 * normalize Date
 * @param date passing date
 * @returns Get normalize date
 */
  normalizeDate(date: string) {
    return (date || "").indexOf('T') > -1 ? date.split('T')[0] : (date || "").indexOf(' ') > -1 ? date.split(' ')[0] : date;
  }
  /**
   * identify mobile device
   * @returns boolean mobile device or not
   */
  isMobileDevice() {
    return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
  }


/**
 * Everytime this function will call while redirecting any component 
 * all condition check here for routing basis
 * @param investor passing investor detail object data
 * @param businessUnit passing bussiness unit MF/JF
 * @param isSkippable is nominee skip or not
 * @returns routing url will pass
 */
  getForwardRoute(investor: Investor, businessUnit: string, isSkippable?) {
    console.log('inside ROUTE')
    let aaStatus= sessionStorage.getItem('Account_aggregator_status')
    let routeInfo: any;
    let screen: string;
    let otpConfig = this.getOtpConfig();
    let mobileIPV = this.getIPVOnMobileCheck();
    let isManualVerification = this.getDigiLockerConfig();
    let isDigioIPVSubmitted = this.getDigioIPVConfig();
    let isDigioSelfieSubmitted = this.getDigioSelfieConfig();
    let checkIPVFilesForRouting = (this.investor.isKYC !== 'Y' && this.investor.investorDetailsDtoList && this.investor.investorDetailsDtoList.length && !this.investor.investorDetailsDtoList[0].kycVerifiedBy);
    let isDirectMFPorting = sessionStorage.getItem('isDirectMFPorting');
    let investorDetails = ((investor || new Investor()).investorDetailsDtoList || [])[0] || new InvestorDetails();
    if (businessUnit == 'MF') {
      routeInfo = '/onboard/' + location.pathname.split('/')[2] + '/';
      let investorAccount = ((investor.investorAccountDetailsDtoList || [])[0] || new InvestorAccount());
      // if (investor && !investorAccount.clientID || investorAccount.isMobileVerified != 'Y') {
      //   screen = 'registration';
      // }
      if (investor && (!investor.id || !investor.pannum || !investorDetails.emailID || !investor.investorAccountDetailsDtoList || !investorDetails.occupation || (investorAccount.isMobileVerified != 'Y' || investorAccount.isEmailVerified != 'Y' || !investorDetails.education || !investorDetails.annualIncome || !investorDetails.politicalRelation))) {
        if (mobileIPV && this.isMobile)
          screen = 'ipv-details';
        else
          screen = 'open-account';
      }
      else if (investor && investor.investorDetailsDtoList && investor.investorDetailsDtoList.length) {
        let ipvDetails = (investor.documentsIPVDtoList || [])[0] || {};
        let invDetails = investor.investorDetailsDtoList[0];
        let bankDetails = investor.investorBankDetailsDtoList;
        let isPorted = investor.isPorting
        let documentDetails = (this.investor.documentsDtoList || [])[0] || new DocumentDetails();
        let invAddresses = investor.addressDtoList;
        let isNRI = investorAccount.isNRI == 'Y';
        let ipvDocumentDto = (investor.documentsIPVDtoList || [])[0] || {};
        let nomineeDetails = (investor.nomineeDetailsDtoList || [])[0];
        let date = ipvDocumentDto.lastModifiedDate ? new Date(ipvDocumentDto.lastModifiedDate.split('T')[0]) : '';
        if (date && date instanceof Date) {
          date.setDate(date.getDate() + 30);
        }
        // date && 
        let isIPVRequired = mobileIPV ? (this.isMobile && mobileIPV) : ((this.investor.isKYC === 'Y') || (this.investor.isKYC !== 'Y' && this.investor.investorDetailsDtoList && this.investor.investorDetailsDtoList.length && this.investor.investorDetailsDtoList[0].kycVerifiedBy) ? false : ((!ipvDocumentDto.ipvVideoFileName && !ipvDocumentDto.ipvImageFileName) || !ipvDocumentDto.createdDate || moment(new Date()).format('YYYY-MM-DD') > moment(date).format('YYYY-MM-DD')));
        if (this.isMobile && mobileIPV && (investor.investorAccountDetailsDtoList[0].isDirectPorting != 'Y' || investor.isPorting != 'Y')) {
          screen = 'ipv-details';
        }
        else if (investor.isKYC != 'Y' && (!invDetails.fatherName || !invDetails.investorName) && !(isManualVerification.isManual || invDetails.kycVerifiedBy || isManualVerification.isDigilocker) && (investor.investorAccountDetailsDtoList[0].isDirectPorting != 'Y' || investor.isPorting != 'Y') ) {
          screen = 'digi-locker';
        }
        else if (investor.isKYC != 'Y' && (!invDetails.fatherName || !invDetails.investorName) && (isManualVerification.isManual || invDetails.kycVerifiedBy || isManualVerification.isDigilocker)) {
          screen = 'basic-details';
        } else if (investor.isKYC != 'Y' && (!invAddresses || !invAddresses.length) && !invDetails.kycVerifiedBy) {
          screen = 'address-details';
        } else if (!invDetails.occupation) {
          screen = 'income-details';
          // || (!bankDetails[0].cancelChequeFileName && bankDetails[0].isPennydropVerified != 'Y')
        } else if (investor.isPorting!=='Y' && (!bankDetails || !bankDetails.length || (!bankDetails[0].cancelChequeFileName && bankDetails[0].isPennydropVerified != 'Y'))) {
          screen = 'bank-details';
          // && investor.isKYC != 'Y' && !invDetails.kycVerifiedBy
        } else if(investor.isPorting==='Y' && (!bankDetails || !bankDetails.length)) {
          screen = 'bank-details';
        }
        // else if (isDirectMFPorting == 'true' && !bankDetails[0].cancelChequeFileName) {
        //   screen = 'bank-details';
        // }
        else if (bankDetails && bankDetails.length && bankDetails[0].accountNumber && isIPVRequired && !isDigioIPVSubmitted.isSubmitted && (investor.investorAccountDetailsDtoList[0].isDirectPorting != 'Y' || investor.isPorting != 'Y')) {
          screen = 'ipv-details';
        } else if (investor.isKYC != 'Y' && (checkIPVFilesForRouting ? (ipvDetails.ipvVideoFileName || ipvDetails.ipvImageFileName || isDigioIPVSubmitted.isSubmitted) : (bankDetails && bankDetails.length && bankDetails[0].accountNumber)) && (!documentDetails.panCardFileName) && (investor.investorAccountDetailsDtoList[0].isDirectPorting != 'Y' || investor.isPorting != 'Y')) {
          screen = 'document-uploads/panCardFile';
        } else if (investor.isKYC != 'Y' && (checkIPVFilesForRouting ? (ipvDetails.ipvVideoFileName || ipvDetails.ipvImageFileName || isDigioIPVSubmitted.isSubmitted) : true) && (!documentDetails.addrProofFrontFileName) && (investor.investorAccountDetailsDtoList[0].isDirectPorting != 'Y' || investor.isPorting != 'Y')) {
          screen = 'document-uploads/addrProofFrontFile';
        } else if (investor.isKYC != 'Y' && (checkIPVFilesForRouting ? (ipvDetails.ipvVideoFileName || ipvDetails.ipvImageFileName || isDigioIPVSubmitted.isSubmitted) : true) && (!documentDetails.photoFileName && !isDigioSelfieSubmitted.isSubmitted) && (investor.investorAccountDetailsDtoList[0].isDirectPorting != 'Y' || investor.isPorting != 'Y')) {
          screen = 'document-uploads/photoFile';
        }
        else if (investor.isKYC === 'Y' && (bankDetails && bankDetails.length && bankDetails[0].accountNumber) && (!documentDetails.photoFileName && !isDigioSelfieSubmitted.isSubmitted) && (investor.investorAccountDetailsDtoList[0].isDirectPorting != 'Y' || investor.isPorting != 'Y')) {
          screen = 'document-uploads/photoFile';
        }
        // else if (!documentDetails.signFileName && (investor.isKYC == 'Y')) {
        //   screen = 'document-uploads/signFile';
        // } else if (investor.isKYC != 'Y' && (checkIPVFilesForRouting ? (ipvDetails.ipvVideoFileName || ipvDetails.ipvImageFileName || isDigioIPVSubmitted.isSubmitted || invDetails.kycVerifiedBy) : true) && (!documentDetails.signFileName)) {
        //   screen = 'document-uploads/signFile';
        // } 
        else if((!documentDetails.signFileName)){
          screen = 'document-uploads/signFile';
        }
        else if (isNRI && !(documentDetails.overseasAddressFrontFileName) && (investor.investorAccountDetailsDtoList[0].isDirectPorting != 'Y' || investor.isPorting != 'Y')) {
          screen = 'document-uploads/overseasAddressFrontFile';
        } else if (isNRI && !(documentDetails.passportFrontFileName) && (investor.investorAccountDetailsDtoList[0].isDirectPorting != 'Y' || investor.isPorting != 'Y')) {
          screen = 'document-uploads/passportFrontFile';
        } else if (isNRI && !(documentDetails.visaFileName) && (investor.investorAccountDetailsDtoList[0].isDirectPorting != 'Y' || investor.isPorting != 'Y')) {
          screen = 'document-uploads/visaFile';
        } else if (!nomineeDetails && documentDetails.signFileName && investor.isNomineeSkipped != 'Y') {
          screen = 'nominee-details';
        } 
        else if (investor.investorAccountDetailsDtoList[0].isOnBoardFlag && investor.investorAccountDetailsDtoList[0].isOnBoardFlag === 'N' && (investor.investorAccountDetailsDtoList[0].isDirectPorting != 'Y' || investor.isPorting != 'Y')  && (investor.isKYC === 'Y' ? investor.investorAccountDetailsDtoList[0].isKraMismatched : true)) {
            screen = 'esign';
          
        }
        // else if (((investor.isKYC == 'Y' && documentDetails.signFileName) ||
        //   (investor.isKYC == 'N' && documentDetails.signFileName && documentDetails.panCardFileName && documentDetails.addrProofFrontFileName) ||
        //   (isNRI && documentDetails.overseasAddressFrontFileName && documentDetails.passportFrontFileName && documentDetails.visaFileName)) && (investorAccount.isOnBoardFlag == 'N')) {
        //   screen = 'document-uploads/finalSub';
        // }
        /* else if (((investor.isKYC == 'Y' && documentDetails.signFileName) ||
      (investor.isKYC == 'N' && documentDetails.signFileName && documentDetails.panCardFileName && documentDetails.addrProofFrontFileName) ||
      (isNRI && documentDetails.overseasAddressFrontFileName && documentDetails.passportFrontFileName && documentDetails.visaFileName)) && (investorAccount.isOnBoardFlag == 'N')) {
      screen = 'document-uploads/signFile';
    } */ else if (((investor.isKYC == 'Y' && documentDetails.signFileName) ||
          (investor.isKYC == 'N' && documentDetails.signFileName && documentDetails.panCardFileName && documentDetails.addrProofFrontFileName) ||
          (isNRI && documentDetails.overseasAddressFrontFileName && documentDetails.passportFrontFileName && documentDetails.visaFileName)) && (investorAccount.isOnBoardFlag == 'Y' || investorAccount.isOnBoardFlag == 'C')) {
          screen = 'congrats';
        } else if (isDirectMFPorting == 'true' || (investor.investorAccountDetailsDtoList[0].isDirectPorting === 'Y' && investor.isPorting === 'Y')) {
          screen = 'congrats';
        }
        else if (investor.isKYC == 'Y' && !investor.investorAccountDetailsDtoList[0].isKraMismatched && documentDetails.signFileName){
          // sessionStorage.setItem('setOnbFlag',investor.investorAccountDetailsDtoList[0].isOnBoardFlag)
          // console.log('JJJJ',this.investor.investorAccountDetailsDtoList[0].isOnBoardFlag)
          // this.investor.investorAccountDetailsDtoList[0].isOnBoardFlag = 'Y';
          // console.log('JJJJ2',this.investor.investorAccountDetailsDtoList[0].isOnBoardFlag)
          screen = 'congrats';
        }
      }
    } else if (businessUnit == 'JF' || businessUnit == 'MFJF') {
      routeInfo = '/onboard/' + location.pathname.split('/')[2] + '/';
      let investorDetails = ((investor || new Investor()).investorDetailsDtoList || [])[0] || new InvestorDetails();
      let investorAccount = ((investor || new Investor()).investorAccountDetailsDtoList || [])[0] || new InvestorAccount();

      if(!investor.pannum || !investorDetails.dateOfBirth){
        screen = 'onboard-info';
      } else if (investor && (!investor.id || !investor.pannum || !investorDetails.emailID || !investor.investorAccountDetailsDtoList || !investorDetails.occupation || ((investorAccount.isMobileVerified != 'Y' || investorAccount.isEmailVerified != 'Y' || !investorDetails.education || !investorDetails.annualIncome || !investorDetails.politicalRelation) && !otpConfig.isSkip))) {
        if (mobileIPV && this.isMobile)
          screen = 'ipv-details';
        else
          screen = 'open-account';
      } else if (investor && investor.investorDetailsDtoList && investor.investorDetailsDtoList.length) {
        let investorAccountDetails = investor.investorAccountDetailsDtoList[0];
        let ipvDetails = (investor.documentsIPVDtoList || [])[0] || {};
        let documentDetails = (this.investor.documentsDtoList || [])[0] || new DocumentDetails();
        let invDetails = investor.investorDetailsDtoList[0];
        let bankDetails = investor.investorBankDetailsDtoList;
        let invAddresses = investor.addressDtoList;
        let segmentDetails = investor.optSegments;
        // let isIncomeProofRequired = (segmentDetails || []).filter((segment: SegmentDetails) => segment.isOpt == 'Y' && ['NSECash', 'BSECash'].indexOf(segment.segmentMasterDto.segmentName) == -1).length;
        let ipvDocumentDto = (investor.documentsIPVDtoList || [])[0] || {};
        let nomineeDetails = investor.nomineeDetailsDtoList;
        let date = ipvDocumentDto.lastModifiedDate ? new Date(ipvDocumentDto.lastModifiedDate.split('T')[0]) : '';
        if (date && date instanceof Date) {
          date.setDate(date.getDate() + 30);
        }
        // date && 
        let isIPVRequired = mobileIPV ? (this.isMobile && mobileIPV) : ((this.investor.isKYC === 'Y') || (this.investor.isKYC !== 'Y' && this.investor.investorDetailsDtoList && this.investor.investorDetailsDtoList.length && this.investor.investorDetailsDtoList[0].kycVerifiedBy) ? false : ((!ipvDocumentDto.ipvVideoFileName && !ipvDocumentDto.ipvImageFileName) || !ipvDocumentDto.createdDate || moment(new Date()).format('YYYY-MM-DD') > moment(date).format('YYYY-MM-DD')));
        if (this.isMobile && mobileIPV) {
          screen = 'ipv-details';
        }
        else if (investor.isKYC != 'Y' && (!invDetails.fatherName || !invDetails.investorName) && !(isManualVerification.isManual || invDetails.kycVerifiedBy || isManualVerification.isDigilocker)) {
          screen = 'digi-locker';
        } else if (investor.isKYC != 'Y' && (!invDetails.fatherName || !invDetails.investorName) && (isManualVerification.isManual || invDetails.kycVerifiedBy || isManualVerification.isDigilocker)) {
          screen = 'basic-details';
        } else if ((!nomineeDetails && documentDetails.signFileName && investor.isNomineeSkipped != 'Y')) {
          screen = 'nominee-details';
        } else if (investor.isKYC != 'Y' && (!invAddresses || !invAddresses.length) && !invDetails.kycVerifiedBy) {
          screen = 'address-details';
        } else if (!bankDetails || !bankDetails.length || ((!bankDetails[0].isPennydropVerified || bankDetails[0].isPennydropVerified != 'Y') && !bankDetails[0].cancelChequeFileName)) {
          screen = 'bank-details';
        } 
        // else if (!segmentDetails || !segmentDetails.length)(!segmentDetails || !segmentDetails.length) {
        //   screen = 'segment-details';
        //   // && investor.isKYC != 'Y' && (!invDetails.kycVerifiedBy)
        // }
         else if (isIPVRequired && !isDigioIPVSubmitted.isSubmitted) {
          screen = 'ipv-details';
        } else if (investor.isKYC != 'Y' && ((ipvDetails.ipvVideoFileName || ipvDetails.ipvImageFileName || isDigioIPVSubmitted.isSubmitted)) && (!documentDetails || !documentDetails.panCardFileName)) {
          screen = 'document-uploads/panCardFile';
        } else if (investor.isKYC != 'Y' && (checkIPVFilesForRouting ? (ipvDetails.ipvVideoFileName || ipvDetails.ipvImageFileName || isDigioIPVSubmitted.isSubmitted) : true) && (!documentDetails.addrProofFrontFileName)) {
          screen = 'document-uploads/addrProofFrontFile';
        } else if (investor.isKYC != 'Y' && (checkIPVFilesForRouting ? (ipvDetails.ipvVideoFileName || ipvDetails.ipvImageFileName || isDigioIPVSubmitted.isSubmitted) : true) && (!documentDetails.photoFileName && !isDigioSelfieSubmitted.isSubmitted)) {
          screen = 'document-uploads/photoFile';
        } else if (investor.isKYC == 'Y'  && (!documentDetails.photoFileName && !isDigioSelfieSubmitted.isSubmitted)) {
          screen = 'document-uploads/photoFile';
        } else if ((investor.isKYC == 'Y' && !documentDetails.signFileName)) {
          screen = 'document-uploads/signFile';
        } else if (investor.isKYC != 'Y' && (checkIPVFilesForRouting ? (ipvDetails.ipvVideoFileName || ipvDetails.ipvImageFileName || isDigioIPVSubmitted.isSubmitted || invDetails.kycVerifiedBy) : true) && (!documentDetails.signFileName)) {
          screen = 'document-uploads/signFile';
          // isIncomeProofRequired && 
        } else if ( (!segmentDetails && (investor.tag != "india-post"))) {
          screen = 'document-uploads/incomeProofFile';
        }
        else if (
          (segmentDetails &&
          investor.tag !== "india-post") &&
          (!investor.documentsDtoList[0].incomeProofFileName ||
          !investor.documentsDtoList[0].incomeProofType) &&
          !["Cash", "SLBM", "MTF", "Cash,SLBM", "Cash,MTF", "Cash,MTF,SLBM","Cash,SLBM,MTF", "MTF,SLBM"].includes(segmentDetails.trim().replace(/\s+/g, '')) && (aaStatus != 'done')
        ) {
          screen = 'document-uploads/incomeProofFile';
        }
        
        // else if ((!investorAccountDetails.plan) || isSkippable) {
        //   screen = 'document-uploads/plans';
        // } 
        // else if (((this.getOnboardingType() || '').trim().toLowerCase() == 'referral' && !investorAccountDetails.brokerageJson) && ((investor.isKYC != 'Y' && (documentDetails && documentDetails.panCardFileName && documentDetails.photoFileName && documentDetails.signFileName && investorAccountDetails.plan)) || (investor.isKYC == 'Y' && documentDetails.signFileName && investorAccountDetails.plan))) {
        //   screen = 'brokerage-details';
        // } 
        else if ((!investorAccount.isReviewed || investorAccount.isReviewed != 'Y') && ((investor.isKYC != 'Y' && (documentDetails && documentDetails.panCardFileName && (documentDetails.photoFileName || isDigioSelfieSubmitted.isSubmitted) && documentDetails.signFileName)) || (investor.isKYC == 'Y' && documentDetails.signFileName))) {
          screen = 'review';
        } else if (investorAccountDetails.isReviewed == 'Y' && (!investorAccountDetails.isOnBoardFlag || investorAccountDetails.isOnBoardFlag == 'N')) {
          screen = 'esign';
        } else if (investorAccountDetails.isReviewed == 'Y' && (investorAccountDetails.isOnBoardFlag == 'Y' || investorAccountDetails.isOnBoardFlag == 'C')) {
          screen = 'congrats';
        }else if (documentDetails.panCardFileName === '' || documentDetails.panCardFileName === null || documentDetails.addrProofFrontFileName === null) {
          screen = 'digi-locker';
        }
        
      }
    }
    //  this.getTotalSteps()
    return { route: routeInfo + screen, screen: screen };
  }
/**
 * Onboarding journey total step for jf and Mf user mention
 * @returns  pass step with business unit
 */
  getTotalSteps() {
    let investor = this.investor;
    let businessUnit = this.businessUnit;
    let invDetails = investor.investorDetailsDtoList[0];
    let investorAccount = ((investor.investorAccountDetailsDtoList || [])[0] || new InvestorAccount());
    let isNRI = investorAccount.isNRI == 'Y';
    let bankDetails = investor.investorBankDetailsDtoList;
    let ipvDetails = (investor.documentsIPVDtoList || [])[0] || {};
    let segmentDetails = investor.optSegments;
    let documentDetails = (this.investor.documentsDtoList || [])[0] || new DocumentDetails();
    let nomineeDetail = (this.investor.nomineeDetailsDtoList);
    let investorAccountDetails = investor.investorAccountDetailsDtoList[0];
    // let isIncomeProofRequired = (segmentDetails || []).filter((segment: SegmentDetails) => segment.isOpt == 'Y' && ['NSECash', 'BSECash'].indexOf(segment.segmentMasterDto.segmentName) == -1).length
    let stepData = {
      MF: [
        /* {key:'registration',ispresent:true,isCompleted:(investor && investorAccount.clientID && investorAccount.isMobileVerified == 'Y')},
        {key:'basic-details',ispresent:investor.isKYC != 'Y',isCompleted:(invDetails.fatherName && invDetails.investorName)},
        {key:'address-details',ispresent:investor.isKYC != 'Y',isCompleted:(investor.addressDtoList && investor.addressDtoList.length)},
        {key:'income-details',ispresent:true,isCompleted:invDetails.occupation},
        {key:'bank-details',ispresent:true,isCompleted:(bankDetails && bankDetails.length)},
        {key:'ipv-details',ispresent:true,isCompleted:ipvDetails.ipvImageFileName}, */
        // && ipvDetails.ipvVideoFileName
        { name: 'PANCARD', key: 'panCardFile', ispresent: ((investor.isKYC == 'N')), isCompleted: documentDetails.panCardFileName },
        // && ipvDetails.ipvVideoFileName
        { name: 'ADDRESS PROOF', key: 'addrProofFrontFile', ispresent: ((investor.isKYC == 'N')), isCompleted: documentDetails.addrProofFrontFileName },
        // ((investor.isKYC == 'N') && ipvDetails.ipvVideoFileName)

        { name: 'PHOTO', key: 'photoFile', ispresent: ((investor.isKYC === 'Y') ? false : true), isCompleted: documentDetails.photoFileName },

        { name: 'SIGNATURE', key: 'signFile', ispresent: true, isCompleted: documentDetails.signFileName },
        { name: 'OVERSEAS ADDRESS PROOF', key: 'overseasAddressFrontFile', ispresent: isNRI, isCompleted: documentDetails.overseasAddressFrontFileName },
        { name: 'PASSPORT', key: 'passportFrontFile', ispresent: isNRI, isCompleted: documentDetails.passportFrontFileName },
        { name: 'VISA', key: 'visaFile', ispresent: isNRI, isCompleted: documentDetails.visaFileName },
        { name: 'NOMINEE', key: 'nominee-details', ispresent: ((investor.isNomineeSkipped === 'Y') ? false : true), isCompleted: (nomineeDetail && nomineeDetail.length) },
        /*   { name:'', key:'congrats',ispresent:true,isCompleted:false} */
      ],
      JF: [
        /*  { name:'', key:'open-account',ispresent:true,isCompleted:false},
         { name:'', key:'basic-details',ispresent:investor.isKYC != 'Y',isCompleted:false},
         { name:'', key:'address-details',ispresent:investor.isKYC != 'Y',isCompleted:false},
         { name:'', key:'bank-details',ispresent:(!bankDetails||!!bankDetails[0]||((!bankDetails[0].isPennydropVerified || bankDetails[0].isPennydropVerified != 'Y') && !bankDetails[0].cancelChequeFileName)),isCompleted:false},
         { name:'', key:'ipv-details',ispresent:investor.isKYC != 'Y' && (!ipvDetails||!ipvDetails.ipvImageFileName),isCompleted:false}, */
        //  && ipvDetails.ipvVideoFileName
        { name: 'PANCARD', key: 'panCardFile', ispresent: ((investor.isKYC != 'Y')), isCompleted: documentDetails.panCardFileName },
        // && ipvDetails.ipvVideoFileName
        { name: 'ADDRESS PROOF', key: 'addrProofFrontFile', ispresent: ((investor.isKYC != 'Y')), isCompleted: documentDetails.addrProofFrontFileName },
        // ((investor.isKYC != 'Y') && ipvDetails.ipvVideoFileName)
        { name: 'PHOTO', key: 'photoFile', ispresent: true, isCompleted: documentDetails.photoFileName },
        { name: 'SIGNATURE', key: 'signFile', ispresent: true, isCompleted: documentDetails.signFileName },
        { name: 'NOMINEE', key: 'nominee-details', ispresent: ((investor.isNomineeSkipped === 'Y') ? false : true), isCompleted: (nomineeDetail && nomineeDetail.length) },
        // { name: 'INCOME PROOF', key: 'incomeProofFile', ispresent: true, isCompleted: documentDetails.incomeProofFileName },
        

        /*  {key:'plans',ispresent:true,isCompleted:false},
         {key:'brokerage-details',ispresent:(((this.getOnboardingType() || '').trim().toLowerCase() == 'referral' && !investorAccountDetails.brokerageJson) && ((investor.isKYC != 'Y' && (documentDetails && documentDetails.panCardFileName && documentDetails.photoFileName && documentDetails.signFileName && investorAccountDetails.plan)) || (investor.isKYC == 'Y' && documentDetails.signFileName && investorAccountDetails.plan))),isCompleted:false},
         {key:'review',ispresent:((investor.isKYC != 'Y' && (documentDetails && documentDetails.panCardFileName && documentDetails.photoFileName && documentDetails.signFileName)) || (investor.isKYC == 'Y' && documentDetails.signFileName)),isCompleted:false},
         {key:'esign',ispresent:(!investorAccountDetails.isOnBoardFlag || investorAccountDetails.isOnBoardFlag == 'N'),isCompleted:false},
         {key:'congrats',ispresent:true,isCompleted:false}, */
      ]
    };
    if((!this.investor.tag) || (this.investor.tag && this.investor.tag != 'india-post')){
      stepData.JF.push({ name: 'INCOME PROOF', key: 'incomeProofFile', ispresent: true, isCompleted: documentDetails.incomeProofFileName });
    }
    //this.shared.setStepData(stepData[businessUnit])
    console.log(stepData[businessUnit] || stepData['MFJF'], "step data");
    return stepData[businessUnit] || stepData['MFJF'];
  }

  /**
   * Config base success message show
   * @param title popup message or sliding message title name 
   * @param message passing message which want to show
   */
  success(title: string, message: string) {
    this.toastr.success(message, title, { closeButton: true });
    this.toastr.success(message, title, { closeButton: true ,
      positionClass: 'toast-bottom-right'});
  }
/**
   * Config base error message show
   * @param title popup message or sliding message title name 
   * @param message passing message which want to show
   */
 error(title: string, message: string) {
  this.toastr.error(message, title, { closeButton: true ,});
  this.toastr.error(message, title, { closeButton: true ,
    positionClass: 'toast-bottom-right' });
}

  /**
   * Config base error message show
   * @param title popup message or sliding message title name 
   * @param message passing message which want to show
   */
   AAerror(title: string, message: string ,time?:any,disabled?:boolean) {
    this.toastr.error(message, title, { closeButton: true ,timeOut:time,disableTimeOut: disabled});
    this.toastr.error(message, title, { closeButton: true ,
      positionClass: 'toast-bottom-right' });
  }

  /**
   * Config base Warning message show
   * @param title popup message or sliding message title name 
   * @param message passing message which want to show
   */
  warning(title: string, message: string) {
    this.toastr.warning(message, title, { closeButton: true });
    this.toastr.warning(message, title, { closeButton: true ,
      positionClass: 'toast-bottom-right' });
  }

  /**
   * Information related message pass
   * @param title popup message or sliding message title name
   * @param message passing message which want to show
   * @param timeout set timer how much message will show
   */
  info(title: string, message: string, timeout?: boolean) {
    this.toastr.info(message, title, { closeButton: true, disableTimeOut: timeout });
    this.toastr.info(message, title, { closeButton: true, disableTimeOut: timeout,
      positionClass: 'toast-bottom-right' });
  }
/**
 * Investor detail updated Value store in session storage
 * @param data update investor detail data 
 */
  updateOnboardingData(data: any) {
    this.investor = data;
    if (this.storage) {
      this.storage.setItem(this.businessUnit, JSON.stringify(this.investor));
    }
  }
/**
 * Investor detail updated Value store in session storage
 * @param data passed investor detail data
 */
  updateModificationData(data: any) {
    this.modification = data;
    if (this.storage) {
      this.storage.setItem(this.businessUnit + 'Modification', JSON.stringify(this.modification));
    }
  }
/**
 * decrypted Refer Code
 */
  getReferCode() {
    let referCode = this.storage.getItem('referCode');
    return referCode ? atob(referCode) : '';
  }
/**
 * store skip in session storage
 */
  setSkip() {
    if (this.storage) {
      this.storage.setItem(this.businessUnit + '_skip', 1);
    }
  }
/**
 * Clear skip in session storage
 */
  clearSkip() {
    if (this.storage && this.storage.getItem(this.businessUnit + '_skip')) {
      this.storage.removeItem(this.businessUnit + '_skip')
    }
  }
/**
 * Getting value from session storage
 * @returns get skip value
 */
  getSkip() {
    if (this.storage && this.storage.getItem(this.businessUnit + '_skip')) {
      return this.storage.getItem(this.businessUnit + '_skip')
    }
    return false;
  }
/**
 * set refercode in session storage
 * @param referCode passing referCode
 */
  setReferCode(referCode: string) {
    this.storage.setItem('referCode', btoa(referCode));
  }
/**
 * Get language in session storage
 * @returns Get language store
 */
  
    getLanguage() {
    // console.log('STT',this.storage.getItem('lang'));
    return this.storage.getItem('lang') || 'en';
  }
/** 
 * store language in session storage
 * @param lang selected language
 */
  setLanguage(lang: string) {
    this.selectedLanguage = lang;
    console.log('LAN',this.selectedLanguage);
    this.storage.setItem('lang', lang);
  }
/**
 * forward message data
 * @param data showing message data
 */
  sendMessage(data) {
    console.log('send message',data)
    // this.selectedLanguage = this.getLanguage();
    this.subject.next(data);
  }
/**
 * Get meassage
 * @returns {Observable<any>} An observable for message.
 */
  getMessage(): Observable<any>{
    // console.log('getmessage')
    return this.subject.asObservable();
  }

  // getMessage2(): Observable<any>{
  //   return this.subject2.asObservable();
  // }
/**
 * parses a JSON string, constructing the otp described by the string
 * @returns Otp data
 */
  getOtpConfig() {
    let data = this.storage.getItem('otpConfig');
    if (data) return JSON.parse(data);
    return {};
  }
/**
 * store otp Config
 * @param value otp Config
 */
  setOtpConfig(value: any) {
    let data = { ...this.getOtpConfig(), ...value };
    this.storage.setItem('otpConfig', JSON.stringify(data));
  }
/**
 * Remove otp Config
 */
  removeOtpConfig() {
    this.storage.removeItem('otpConfig');
  }
/**
 * getting lms id and decrypt it
 * @returns decrypt Lms id
 */
  getLMSId() {
    let lmsId = this.storage.getItem('lmsId');
    return lmsId ? atob(lmsId) : '';
  }
/**
 * decrypt lmsId  using btoa 
 * @param lmsId lmsId
 */
  setLMSId(lmsId: string) {
    this.storage.setItem('lmsId', btoa(lmsId));
  }
/**
 * store decrypt entityId  using btoa
 * @param entityId entity Id
 */
  setEntityId(entityId: string) {
    this.storage.setItem('entityId', btoa(entityId));
  }
/**
 * get EntityId
 * @returns decrypt EntityId
 */
  getEntityId() {
    let entityId = this.storage.getItem('entityId');
    return entityId ? atob(entityId) : '';
  }
/**
 * get formName
 * @returns decrypt formName value
 */
  getForm() {
    let formName = this.storage.getItem('formName');
    return formName ? atob(formName) : '';
  }

  /**
   * store FormName in decrypt format
   * @param formName passing FormName
   */
  setForm(formName: any) {
    this.storage.setItem('formName', btoa(formName));
  }

  /**
   * Get source value
   * @returns decrypt source value
   */
  getSource() {
    let source = this.storage.getItem('source');
    return source ? atob(source) : '';
  }

  /**
   * store decryt source value
   * @param source passing source value
   */
  setSource(source: string) {
    this.storage.setItem('source', btoa(source));
  }
/**
 * remove Refer code
 */
  removeReferCode() {
    this.storage.removeItem('referCode');
  }
/**
 * remove source
 */
  removeSource() {
    this.storage.removeItem('source');
  }
/**
 * Remove LMS Id
 */
  removeLMSId() {
    this.storage.removeItem('lmsId');
  }
/**
 * Remove Entity Id
 */
  removeEntityId() {
    this.storage.removeItem('entityId');
  }
/** Remove Form value */
  removeForm() {
    this.storage.removeItem('formName');
  }
/**
 * Get decryt Onboarding Type
 * @returns  decryt Onboarding Type
 */
  getOnboardingType() {
    let obType = this.storage.getItem('obType');
    return obType ? atob(obType) : '';
  }
/** Remove Onboarding Type */
  removeOnboardingType() {
    this.storage.removeItem('obType');
  }

  /**
   * store onboarding type
   * @param obType passing onboarding type
   */
  setOnboardingType(obType) {
    this.storage.setItem('obType', btoa(obType));
  }

  /**
   * store lead Data
   * @param data pass lead data
   * @param businessUnit passing business unit 
   */
  storeLeadData(data: any, businessUnit: string) {
    this.storage.setItem('lms' + businessUnit, JSON.stringify(data));
  }

  /**
   * Get lms data
   * @param businessUnit passing business unit
   * @returns decrypted LMS data
   */
  getLMSData(businessUnit: string) {
    let lmsData = this.storage.getItem('lms' + businessUnit);
    if (lmsData) return JSON.parse(lmsData);
    return { leadMappingDtoList: [] };
  }
/**
 * Remove LMS Data
 * @param businessUnit passing business Unit
 */
  removeLMSData(businessUnit: string) {
    this.storage.removeItem('lms' + businessUnit);
  }
/**
 * Indentify device
 * @returns get device
 */
  getOS() {
    let agent = navigator.userAgent.toLowerCase();
    let version;
    let browser = "";
    let device = (/Android/i).test(agent) ? 'Android' : (/BlackBerry/i).test(agent) ? 'BlackBerry' : (/iPhone|iPad|iPod/i).test(agent) ? 'iOS' :
      (/WPDesktop|IEMobile|Win/i).test(agent) ? 'Windows' : (/Linux|X11/i).test(agent) ? 'Linux' : (/Mac/i).test(agent) ? 'Macintosh' : 'NA';
    let mobileOrDesktop = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(agent)) ? 'Mobile' : 'Desktop';
    (version = agent.match(/msie ([\d.]+)/)) ? browser = "IE " + version[1] :
      (version = agent.match(/firefox\/([\d.]+)/)) ? browser = "FireFox " + version[1] :
        (version = agent.match(/chrome\/([\d.]+)/)) ? browser = "Chrome " + version[1] :
          (version = agent.match(/opera.([\d.]+)/)) ? browser = "Opera " + version[1] :
            (version = agent.match(/version\/([\d.]+).*safari/)) ? browser = "Safari " + version[1] : "NA";
            if(device === 'NA'){
              device = this.getOSLatest()
            }
    return mobileOrDesktop + '_' + device + '_' + browser;
  }
/** identify device */
  getOSLatest(){

    let device = navigator['userAgentData'].platform || navigator.userAgent;

    return device
  }
/**
 * set step name accourding to screen name
 * @param screenName  passing screen name
 */
  setStep(screenName?: string) {
    let url ;
    let businessUnit = this.businessUnit;
    if(this.businessUnit == "MF" && location.pathname.includes('onboard-info')){
      url = (screenName || location.pathname.split('/')[location.pathname.split('/').length - 2] || '').replace('/', '');
    }else{
      url = (screenName || location.pathname.split('/')[location.pathname.split('/').length - 1] || '').replace('/', '');
    }
    if (this.config.screens[url]) {
      let step = (this.config.screens[url].step || this.config.screens[url])[businessUnit];
      this.config.step = this.config.step || {};
      this.config.step[businessUnit] = (this.config.step[businessUnit] || 0) > step ? (this.config.step[businessUnit] || 0) : step;
      if (this.storage) {
        this.storage.setItem('step', JSON.stringify(this.config.step));
      }
    }
  }
/**
 * identify which screen according to step
 * @returns get step
 */
  getStep() {
    if (this.storage) {
      let data = this.storage.getItem('step');
      if (data) return JSON.parse(data);
      return (this.config.step || {})[this.businessUnit] || {};
    }
    return (this.config.step || {})[this.businessUnit] || {};
  }
/**
 * Clear step
 */
  clearStep() {
    if (this.storage) {
      this.storage.removeItem('step');
    }
    this.config.step = {};
  }
/**
 * Get investor detail data
 * @returns  investor detail object
 */
  getOnboardingData() {
    
    if (this.storage) {
      if(!sessionStorage.getItem('closureId')){
        let data = this.storage.getItem(this.businessUnit);
        if (data) return JSON.parse(data);
      }
     
      return this.investor;
    }
    return this.investor;
  }
/**
 * Remove investor detail
 */
  removeOnboardingData() {
    let data = this.storage.getItem(this.businessUnit);
    if (data)
      this.storage.removeItem(this.businessUnit);
  }
/**
 * modification data
 * @returns get modification data
 */
  getModificationData() {
    if (this.storage) {
      let data = this.storage.getItem(this.businessUnit + 'Modification');
      if (data) return JSON.parse(data);
      return this.modification;
    }
    return this.modification;
  }
/**
 * Get investor detail data
 * @param investor investor detail data
 * @returns Investor detail dto list
 */
  getInvestorAccount(investor?: Investor): InvestorAccount {
    investor = investor || this.investor;
    return investor.investorAccountDetailsDtoList && investor.investorAccountDetailsDtoList.length ? investor.investorAccountDetailsDtoList[0] : new InvestorAccount();
  }
/**
 * Get investor detail Dto List data
 * @param investor investor detail data
 * @returns investor detail investor Details Dto List data
 */
  getInvestorDetails(investor?: Investor): InvestorDetails {
    investor = investor || this.investor;
    return investor.investorDetailsDtoList[0] || new InvestorDetails();
  }

/**
 * indian value boolean
 * @param value passing value 
 * @returns value 
 */
  isIndian(value: string) {
    return new RegExp(/^india$/i).test(value || '');
  }
/**
 * Normalizes a name string by removing invalid characters and extra spaces.
 * This method removes any characters from the input string that are not alphabets, periods, apostrophes, hyphens, or spaces.
 * It also replaces multiple consecutive spaces with a single space.
 * Get Address List
 * @param addressList 
 * @returns passing address array list
 */
  normalizeAddress(addressList: Array<AddressDetails>) {
    let investor: Investor = this.getOnboardingData() || {};
    if (addressList && addressList.length) {
      if (addressList.length == 1) {
        let addressObject: AddressDetails = JSON.parse(JSON.stringify(addressList[0]));
        addressObject.addressType = addressObject.addressType == 'Current' ? 'Permanent' : 'Current';
        addressObject.id = null;
        addressList.push(addressObject);
      }
      let addressChars = new RegExp(/[A-z0-9]/ig);
      let pinCodeChars = new RegExp(/[0-9]/ig);
      addressList.forEach((addressObject: AddressDetails, index) => {
        // addressObject.address = addressObject.address.replace(/[^A-Za-z0-9\s\'-:.,\(\[\]\)]+/g, '').replace(/\s+/g, ' ');
        // addressObject.city = addressObject.city.replace(/[^A-Za-z\s\-\.]+/g, '').replace(/\s+/g, ' ');
        addressObject.id = ((investor.addressDtoList || [])[index] || new AddressDetails()).id || null;
        addressObject.investorId = addressObject.id ? investor.id : null;
      });
      addressList.forEach((addressObject: AddressDetails, index) => {
        let otherIndex = index ? 0 : 1;
        addressObject.address = ((addressChars.test(addressObject.address) ? addressObject.address : addressChars.test(addressList[otherIndex].address) ? addressList[otherIndex].address : addressObject.address) || '').replace(/\s+/g, ' ');
        addressObject.city = ((addressChars.test(addressObject.city) ? addressObject.city : addressChars.test(addressList[otherIndex].city) ? addressList[otherIndex].city : addressObject.city) || 'OTHERS').replace(/\s+/g, ' ');
        addressObject.state = ((addressChars.test(addressObject.state) ? addressObject.state : addressChars.test(addressList[otherIndex].state) ? addressList[otherIndex].state : addressObject.state) || '').replace(/\s+/g, ' ');
        addressObject.zipCode = pinCodeChars.test(addressObject.zipCode) ? addressObject.zipCode : pinCodeChars.test(addressList[otherIndex].zipCode) ? addressList[otherIndex].zipCode : addressObject.zipCode;
      });
    }
    return addressList;
  }
/**
 * Normalizes a name string by removing invalid characters and extra spaces.
 * 
 * This method removes any characters from the input string that are not alphabets, periods, apostrophes, hyphens, or spaces.
 * It also replaces multiple consecutive spaces with a single space.
 * 
 * @param value - The name string to be normalized.
 * @returns  The normalized name string.
 */
 normalizeNames(value: string): string {
  return (value || '').replace(/[^A-Za-z\.\'\- ]/g, '').replace(/\s+/g, ' ');
}

/**
 * getting current screen
 * @param investorAccount investor Account Detail 
 * @returns passes current screen
 */
  assignScreen(investorAccount: InvestorAccount) {
    let screenName = (investorAccount.screenName || '').toLowerCase();
    let url = location.pathname.split('/');
    let index = ((location.pathname.indexOf('document-uploads') > -1) || (this.businessUnit == 'MF' && location.pathname.indexOf('onboard-info')> -1)) ? 2 : 1
    let currentScreen = this.config.screens[url[url.length - index]];
    // let lastScreen: any = screenName ? Object.values(this.config.screens).find((screen: any) => (screen.label || '').toLowerCase() == screenName) : currentScreen;
    // return currentScreen && currentScreen.label && lastScreen && lastScreen.step.id >= currentScreen.step.id ? currentScreen : lastScreen;
    return currentScreen
  }
/**
 * Updated  investor Detail
 ** This method gathers the necessary investor data, such as device ID, LMS ID, entity ID, account details, and investor segments,
 * and submits the updated investor information to the backend. It also handles various investor details such as plan, referred ID,
 * @param callback - An optional callback function to be executed after a successful investor update.
 * @param hideLoader boolean loader
 * @param contactUpdationType contact Updation Type
 * @param noNavigation  boolean Navigation
 */
  updateInvestorDetails(callback?: Function, hideLoader?: boolean, contactUpdationType?:string, noNavigation?: boolean ) {
    let deviceID = this.getOS();
    this.rest.showLoader("Saving your details..");
    this.investor.deviceID = deviceID;
    this.investor.lid = this.getLMSId() || this.investor.lid || null;
    this.investor.entityId = this.getEntityId() || this.investor.entityId || null;
    if (this.investor.investorAccountDetailsDtoList && this.investor.investorAccountDetailsDtoList.length) {
      let investorDetails = ((this.investor.investorDetailsDtoList || [])[0] || new InvestorDetails());
      this.investor.investorAccountDetailsDtoList[0].deviceID = deviceID;
      let investorAccount = ((this.investor.investorAccountDetailsDtoList || [])[0] || new InvestorAccount());
      let isAlphabee = ((this.getLMSData(this.businessUnit) || {}).leadSource || '').toLowerCase().indexOf('alphabee') > -1
      this.investor.investorAccountDetailsDtoList[0].originalSource = location.pathname.indexOf('/respond-issue') > -1 ? this.investor.investorAccountDetailsDtoList[0].originalSource : this.getOnboardingType() == 'REFERRAL' ? 'JIFFY_OFFLINE' : this.getOnboardingType() == 'Alphabee' || isAlphabee ? 'ALPHABEE' : (this.getSource() || this.getOriginalSource());
      investorAccount.referredID = (isAlphabee) ? null : (investorAccount.referredID || this.getReferCode() || '')
      location.pathname.indexOf('/review') == -1 ? this.investor.investorAccountDetailsDtoList[0].isReviewed = 'N' : '';
      this.investor.investorAccountDetailsDtoList[0].referredID = this.investor.investorAccountDetailsDtoList[0].referredID || this.getReferCode();
      // || 'Annual AMC Plan'
      this.investor.investorAccountDetailsDtoList[0].plan = this.investor.investorAccountDetailsDtoList[0].plan;
      investorDetails.politicalRelation = (investorDetails.politicalRelation && investorDetails.politicalRelation==='N') ? 'NPEP_NRPEP' : investorDetails.politicalRelation;
      let screenObject = this.assignScreen(this.investor.investorAccountDetailsDtoList[0]);
      if (screenObject) {
        // this.investor.investorAccountDetailsDtoList[0].screenName = (screenObject.step && screenObject.step.label) || screenObject.label || '';
        // this.investor.investorAccountDetailsDtoList[0].screenIdentifierId = (screenObject.screen && screenObject.screen.id) || screenObject.id || '1';
        /**Onboarding Moengage Event Handling for Label */
        this.investor.investorAccountDetailsDtoList[0].screenName = (screenObject.screen && screenObject.screen.name) || screenObject.label || '';
        this.investor.investorAccountDetailsDtoList[0].screenIdentifierId = (screenObject.screen && screenObject.screen.id) || screenObject.id || '1';
      }
    }
    if (this.businessUnit != 'MF') {
      let investorAccount = ((this.investor.investorAccountDetailsDtoList || [])[0] || new InvestorAccount());
      let isAlphabee = (investorAccount.originalSource) ? investorAccount.originalSource.toLowerCase().indexOf('alphabee') > -1 : '';
      // let obtype = ((this.getLMSData(this.businessUnit) || {}).leadSource || '').toLowerCase().indexOf('alphabee') > -1;
      investorAccount.referredID = (isAlphabee) ? null : (investorAccount.referredID || this.getReferCode() || '')
      // this.investor.investorSegmentDtoList = (isAlphabee) ? this.optSegments(isAlphabee ? 'Cash' : 'All', this.investor.id) : this.investor.investorSegmentDtoList;
      // && this.investor.investorSegmentDtoList.length ? this.investor.investorSegmentDtoList : this.optSegments(isAlphabee ? 'Cash' : 'All', this.investor.id);
      let investorDetails = ((this.investor.investorDetailsDtoList || [])[0] || new InvestorDetails());
      investorDetails.incomeSlab = investorDetails.incomeSlab || '1-5 Lacs';
      investorDetails.education = investorDetails.education || 'Graduate';
      investorDetails.experience = investorDetails.experience || '0';
      investorDetails.politicalRelation = (investorDetails.politicalRelation && investorDetails.politicalRelation==='N') ? 'NPEP_NRPEP' : investorDetails.politicalRelation;
      this.investor.investorDetailsDtoList = [investorDetails];
      this.investor.investorAccountDetailsDtoList = [investorAccount];
    }
    this.rest.updateInvestor(this.investor, this.investor.id, hideLoader, contactUpdationType).subscribe((res) => {
      this.rest.hideLoader();
      if (res && res.errorCode == '9999' || res.errorCode == '0053') {
        let investorAccount = ((this.investor.investorAccountDetailsDtoList || [])[0] || new InvestorAccount());
        
        if(res.message && (res.message.trim() === 'Income Proof File Missing.') && investorAccount.isMobileVerified == 'Y' && investorAccount.isEmailVerified == 'Y'){ 
          
        this.AAerror('Error','Unable to fetch your income document through CAMS. Please upload it manually.',4000,false)
        setTimeout(() => {
        let route = this.getForwardRoute(this.investor, this.businessUnit)
        this.setStep(route.screen);
        this.route.navigate([route.route]);
       }, 4000);
          
        }else{
          this.error('Error', res.message);
        }
       
      } else if (res && res.errorCode == '0054') {
        let lmsData = this.getLMSData(this.businessUnit);
        let msg = 'Record with your name: <b>' + lmsData.firstName + '</b> and mobile number: <b>' + lmsData.mobileNo1 + '</b> already exists';
        this.showModal({
          title: 'Attention!!',
          message: msg,
          actions: [
            {
              label: this.errorMessages.okaybtn,
              handler: () => {
                this.utils.modalConfig = null;
                location.href = this.getRedirectionURL('signUpURL');
              }
            }
          ]
        })
      }
      else if (res && res.errorCode && res.errorCode == 3002){
        this.error('Error', res.message);
      }
      else if (res && !res.errorCode && !noNavigation) {
        this.investor = res;
        this.setStep();
        this.updateScreenDetails(hideLoader);
        this.updateOnboardingData(this.investor);
        if (callback) callback();
      }else if(res && !res.errorCode && noNavigation){
        this.investor = res;
        this.updateOnboardingData(this.investor);
        if(callback) callback();
      }
    },
    (error) => {
      this.error('Error', 'Something went wrong.');
      this.rest.hideLoader();
    })
  }
   /**
 * Updates investor details and submits them to the server.
 * 
 * This method gathers the necessary investor data, such as device ID, LMS ID, entity ID, account details, and investor segments,
 * and submits the updated investor information to the backend. It also handles various investor details such as plan, referred ID,
 * and screen identifiers. The function optionally takes a callback to be executed upon successful submission.
 * @param [callback] - An optional callback function to be executed after a successful investor update.
 */
  updateInvestorDetailsSubmit(callback?: Function) {
    let deviceID = this.getOS();
    this.investor.deviceID = deviceID;
    this.investor.lid = this.getLMSId() || this.investor.lid || null;
    this.investor.entityId = this.getEntityId() || this.investor.entityId || null;
    if (this.investor.investorAccountDetailsDtoList && this.investor.investorAccountDetailsDtoList.length) {
      this.investor.investorAccountDetailsDtoList[0].deviceID = deviceID;
      this.investor.investorAccountDetailsDtoList[0].originalSource = this.getOnboardingType() == 'REFERRAL' ? 'JIFFY_OFFLINE' : (this.getSource() || this.getOriginalSource());
      location.pathname.indexOf('/review') == -1 ? this.investor.investorAccountDetailsDtoList[0].isReviewed = 'N' : '';
      this.investor.investorAccountDetailsDtoList[0].referredID = this.investor.investorAccountDetailsDtoList[0].referredID || this.getReferCode();
      this.investor.investorAccountDetailsDtoList[0].plan = this.investor.investorAccountDetailsDtoList[0].plan || 'Annual AMC Plan';
      let screenObject = this.assignScreen(this.investor.investorAccountDetailsDtoList[0]);
      if (screenObject) {
        this.investor.investorAccountDetailsDtoList[0].screenName = screenObject.step.label;
        this.investor.investorAccountDetailsDtoList[0].screenIdentifierId = screenObject.screen.id
      }
    }
    if (this.businessUnit != 'MF') {
      this.investor.investorSegmentDtoList = this.investor.investorSegmentDtoList;
      //  && this.investor.investorSegmentDtoList.length ? this.investor.investorSegmentDtoList : this.optSegments('All', this.investor.id);
      // this.optSegments('Cash', this.investor.id)
      let investorDetails = ((this.investor.investorDetailsDtoList || [])[0] || new InvestorDetails());
      investorDetails.incomeSlab = investorDetails.incomeSlab;
      // || '1-5 Lacs'
      investorDetails.education = investorDetails.education || 'Graduate';
      investorDetails.experience = investorDetails.experience || '0';
      this.investor.investorDetailsDtoList = [investorDetails];
    }
    this.rest.updateInvestor(this.investor, this.investor.id).subscribe((res) => {
      /* if (res && res.errorCode) {
        this.error('Error', (res.message?res.message:'Something went wrong.'));
      } */
      if (res && res.errorCode == '9999' || res.errorCode == '0053') {
        this.error('Error', res.message);
      } else if (res && !res.errorCode) {
        this.investor = res;
        /*    this.setStep();
           this.updateScreenDetails(); */
        this.updateOnboardingData(this.investor);
        if (callback) callback();
      }
    })
  }

  
/**
 * Getting file name
 * @param fileType Passing file Type
 * @param fileExt Passing  file Extension
 * @param suffix Passing suffix
 * @param investorId Passing investor Id
 * @returns get file name
 */
  getFileName(fileType: string, fileExt: string, suffix?: string, investorId?: string) {
    return (investorId || this.investor.id) + '_' + this.businessUnit + '_' + fileType + (suffix || '') + '.' + fileExt;
  }
/**
 * screen Detail updated value
 * @param hideLoader loader boolean value
 * @param isEsignFromCongrats reach congratulation page or not
 */
  updateScreenDetails(hideLoader?: boolean, isEsignFromCongrats?: boolean) {
    let id = this.investor.id || this.getOnboardingData().id;
    if (id) {
      let url = location.pathname.split('/');
      let businessUnit = this.businessUnit == 'MFJF' ? 'JF' : this.businessUnit;
      let index = ((location.pathname.indexOf('document-uploads') > -1) || (this.businessUnit == 'MF' && location.pathname.indexOf('onboard-info')> -1)) ? 2 : 1
      let screenName = url[url.length - index];
      if (this.config.screens[screenName] && this.config.screens[screenName].screen) {
        let request = {
          "businessUnitMasterDto": {
            "id": URLs[businessUnit].id,
            "name": businessUnit,
            "smsSenderKey": ""
          },
          "id": "",
          "investorId": id,
          "screenIdentifierDto": {
            "id": this.config.screens[screenName].screen.id,
            "name": this.config.screens[screenName].screen.name
          }
        }
        if (isEsignFromCongrats) {
          request.screenIdentifierDto.id = this.config.screens['esign'].screen.id;
          request.screenIdentifierDto.name = this.config.screens['esign'].screen.name;
        }
        this.rest.updateOnboardingScreen(request, id, hideLoader).subscribe((res) => {
          if(res){
            // if(request && request.screenIdentifierDto && request.screenIdentifierDto.name == 'bank-details'){
            //   this.addDataLayer('dlBankDetailsSuccess',this.investor.id); 
            // }else if(request && request.screenIdentifierDto && request.screenIdentifierDto.name == 'document-uploads' && window.location.href.indexOf('signFile') > -1){
            //   this.addDataLayer('dlSignatureSuccess',this.investor.id);
            // }
          }
        })
      }
    }
  }
/**
 * Getting file extension
 * @param file  file extension
 * @returns file extension
 */
  getFileExtension(file: File | string) {
    let value = (file || {})['type'] ? (file['type'] || '').toLowerCase() : (file || '')['toLowerCase']();
    return value.indexOf('jpeg') > -1 || value.indexOf('jpg') > -1 ? 'jpg' : value.indexOf('png') > -1 ? 'png' : value.indexOf('bmp') > -1 ? 'bmp' : value.indexOf('pdf') > -1 ? 'pdf' : value.indexOf('webm') > -1 ? 'webm' : null;
  }
/**
 * Getting isBase64Encoded value
 * @param value passing value  
 * @returns encoded value 
 */
  isBase64Encoded(value: string) {
    return /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))$/.test((value || '').trim())
  }
/**
 *  Getting screen detail list
 * @param investor passing investor detail
 * @param businessUnit passing businessunit
 * @returns  screen detail
 */
  getAccessList(investor: Investor, businessUnit: string): Array<string> {
    // debugger
    // let isManualVerification = this.getDigiLockerConfig();
    let mobileIPV = this.getIPVOnMobileCheck();
    let isDigioIPVSubmitted = this.getDigioIPVConfig();
    let checkIPVFilesForRouting = (this.investor.isKYC !== 'Y' && this.investor.investorDetailsDtoList && this.investor.investorDetailsDtoList.length && !this.investor.investorDetailsDtoList[0].kycVerifiedBy);
    let ipvDocumentDto = (investor.documentsIPVDtoList || [])[0] || {};
    let nomineeDetails = investor.nomineeDetailsDtoList;
    let date = ipvDocumentDto.lastModifiedDate ? new Date(ipvDocumentDto.lastModifiedDate.split('T')[0]) : '';
    if (date && date instanceof Date) {
      date.setDate(date.getDate() + 30);
    }
    // date && 
    let isIPVRequired = mobileIPV ? (this.isMobile && mobileIPV) : ((this.investor.isKYC === 'Y') || (this.investor.isKYC !== 'Y' && this.investor.investorDetailsDtoList && this.investor.investorDetailsDtoList.length && this.investor.investorDetailsDtoList[0].kycVerifiedBy) ? false : ((!ipvDocumentDto.ipvVideoFileName && !ipvDocumentDto.ipvImageFileName) || !ipvDocumentDto.createdDate || moment(new Date()).format('YYYY-MM-DD') > moment(date).format('YYYY-MM-DD')));
    let IPVRequiredForBrokerage = (this.investor.isKYC !== 'Y' && this.investor.investorDetailsDtoList && this.investor.investorDetailsDtoList.length && this.investor.investorDetailsDtoList[0].kycVerifiedBy) ? false : ((!ipvDocumentDto.ipvVideoFileName && !ipvDocumentDto.ipvImageFileName) || !ipvDocumentDto.createdDate || moment(new Date()).format('YYYY-MM-DD') > moment(date).format('YYYY-MM-DD'));

    let detailsScreen = ['onboard-info'];
    if (this.isMobile && mobileIPV) {
      detailsScreen.push('ipv-details');
    }
    if (investor && investor.pannum && investor.investorDetailsDtoList && investor.investorDetailsDtoList.length && investor.investorDetailsDtoList[0].dateOfBirth) {
      detailsScreen.push('open-account');
    } if (investor && investor.investorDetailsDtoList && investor.investorDetailsDtoList.length) {
      let investorAccountDetails = investor.investorAccountDetailsDtoList[0];
      let ipvDetails = (investor.documentsIPVDtoList || [])[0] || {};
      let invDetails = investor.investorDetailsDtoList[0];
      let bankDetails = investor.investorBankDetailsDtoList;
      let documentDetails = (investor.documentsDtoList || [])[0] || new DocumentDetails();
      let invAddresses = investor.addressDtoList;
      let segmentDetails = investor.investorSegmentDtoList;

      // let isIncomeProofRequired = (segmentDetails || []).filter((segment: SegmentDetails) => segment.isOpt == 'Y' && ['NSECash', 'BSECash'].indexOf(segment.segmentMasterDto.segmentName) == -1).length;
      let isReferralTypeOnboarding = (this.getOnboardingType() || '').trim().toLowerCase() == 'referral';
      if (investor.pannum && invDetails.dateOfBirth && investor.isKYC != 'Y') {
        detailsScreen.push('digi-locker');
      }
      if (investor.pannum && invDetails.dateOfBirth && investor.isKYC != 'Y') {
        detailsScreen.push('basic-details');
      }
      // if (businessUnit == 'JF' && investor.isNomineeSkipped && investor.isNomineeSkipped === 'N' && !nomineeDetails) {
      //   detailsScreen.push('nominee-details');
      // }
      if (invDetails.fatherName && invDetails.investorName && investor.isKYC != 'Y' && !invDetails.kycVerifiedBy) {
        detailsScreen.push('address-details');
      } if (businessUnit == 'MF' && invAddresses && invAddresses.length) {
        detailsScreen.push('income-details');
      } if ((businessUnit == 'MF' && invDetails.occupation) || ((businessUnit == 'JF' || businessUnit == 'MFJF') && invAddresses && invAddresses.length)) {
        detailsScreen.push('bank-details');
        // && investor.isKYC != 'Y' && !invDetails.kycVerifiedBy
      } if (businessUnit == 'MF' && bankDetails && bankDetails.length && documentDetails && documentDetails.chequeFileName && isIPVRequired && !isDigioIPVSubmitted.isSubmitted) {
        detailsScreen.push('ipv-details');
        // && investor.isKYC != 'Y' && !invDetails.kycVerifiedBy
      } if ((businessUnit == 'JF' || businessUnit == 'MFJF') && isIPVRequired && !isDigioIPVSubmitted.isSubmitted) {
        detailsScreen.push('ipv-details');
      }
      if(businessUnit == 'MF' && !documentDetails.signFileName){
        detailsScreen.push('document-uploads');
      }
      if (businessUnit == 'JF' && bankDetails && bankDetails.length && bankDetails[0].accountNumber && (checkIPVFilesForRouting ? (ipvDetails.ipvVideoFileName || ipvDetails.ipvImageFileName || isDigioIPVSubmitted.isSubmitted) : true)) {
        // ((ipvDetails.ipvVideoFileName || invDetails.kycVerifiedBy) || (!ipvDetails.ipvVideoFileName && investor.isKYC == 'Y'))
        //original -> && (ipvDetails.ipvVideoFileName || (!ipvDetails.ipvVideoFileName && investor.isKYC == 'Y'))
        detailsScreen.push('document-uploads');
      }
      // if(businessUnit == 'JF' && bankDetails && bankDetails.length && bankDetails[0].accountNumber && (checkIPVFilesForRouting ? (ipvDetails.ipvVideoFileName || ipvDetails.ipvImageFileName || isDigioIPVSubmitted.isSubmitted) : true) && documentDetails.signFileName){
      //   detailsScreen.push('nominee-details');
      // }
      // isIncomeProofRequired && 
      if ((businessUnit == 'JF' || businessUnit == 'MFJF') && investorAccountDetails.isOnBoardFlag == 'N') {
        if ((investor.isKYC != 'Y' && (IPVRequiredForBrokerage ? (ipvDetails.ipvVideoFileName || ipvDetails.ipvImageFileName || isDigioIPVSubmitted.isSubmitted) : true) && documentDetails.signFileName && documentDetails.photoFileName && documentDetails.panCardFileName &&
          documentDetails.addrProofFrontFileName) || (investor.isKYC == 'Y' && documentDetails.signFileName) || (documentDetails.incomeProofFileName)) {
          // if (isReferralTypeOnboarding) {
          //   detailsScreen.push('brokerage-details');
          // }
          detailsScreen.push('review');
          detailsScreen.push('nominee-details');
        }
        if (investorAccountDetails.isReviewed == 'Y') {
          detailsScreen.push('esign');
        }
      }
      if(businessUnit == 'MF' && investorAccountDetails.isOnBoardFlag == 'N' && investor.isNomineeSkipped && investor.isNomineeSkipped === 'N' && !nomineeDetails) {
        detailsScreen.push('nominee-details');
      }
      if(businessUnit == 'MF' && documentDetails.signFileName && (investor.isNomineeSkipped === 'Y' || nomineeDetails )&&(!investorAccountDetails.isOnBoardFlag || investorAccountDetails.isOnBoardFlag == 'N')&& (investor.investorAccountDetailsDtoList[0].isDirectPorting != 'Y' || investor.isPorting != 'Y')  && (investor.isKYC === 'Y' ? investor.investorAccountDetailsDtoList[0].isKraMismatched : true)) {
        detailsScreen.push('esign');
      }
      if (investorAccountDetails.isOnBoardFlag == 'Y' || investorAccountDetails.isOnBoardFlag == 'C') {
        detailsScreen.push('congrats');
      }
    }
    // this.getTotalSteps()
    return detailsScreen;
  }
/**
 * Validates a pan value using a regular expression.
 * @param value The pan value string to be validated.
 * @returns {RegExpExecArray | null} The result of the regex execution. Returns a match array if the pan value is valid, or null if it's invalid.
 */
  isPANValid(value) {
    return panNumberRegex.exec((value || '').trim())
  }
/**
 * Validates a mobile number using a regular expression.
 * This method checks if the provided mobile number matches the expected format based on the regular expression.
 * @param  value - The mobile number string to be validated.
 * @returns {RegExpExecArray | null} The result of the regex execution. Returns a match array if the mobile number is valid, or null if it's invalid.
 */
  isMobileValid(value) {
    return mobileNumberRegex.exec((value || '').trim())
  }
/**
 * Validates a Email using a regular expression.
 * This method checks if the provided Email matches the expected format based on the regular expression.
 * @param  value - The Email string to be validated.
 * @returns {RegExpExecArray | null} The result of the regex execution. Returns a match array if the Email is valid, or null if it's invalid.
 */
  isEmailValid(value) {
    return emailRegex.exec((value || '').trim())
  }
/**
 * Validates a Refer Code using a regular expression.
 * This method checks if the provided Refer Code matches the expected format based on the regular expression.
 * @param  value - The Refer Code string to be validated.
 * @returns {RegExpExecArray | null} The result of the regex execution. Returns a match array if the Refer Code is valid, or null if it's invalid.
 */
  isReferCodeValid(value) {
    return /^[a-z0-9]+$/i.exec((value || '').trim())
  }
/**
 * Geting Modification Redirection URL
 * @param isPrev 
 * @returns Modification URL
 */
  getModificationRedirectURL(isPrev?: boolean) {
    let urlMapper = {
      'client-login': { allNext: 'segment-activation' },
      'segment-activation': { allPrev: 'client-login', allNext: 'contact-details' },
      'contact-details': { allPrev: 'segment-activation', allNext: 'bank-modification' },
      'bank-modification': { allPrev: 'contact-details', allNext: 'review-form' },
      'review-form': { allPrev: 'bank-modification', allNext: 'client-login' }
    }
    let currentUrl = location.pathname.toLowerCase();
    let lastPath: any = currentUrl.split('/');
    lastPath = lastPath[lastPath.length - 1];
    let isAllModification = location.search.indexOf('?redirect=all') > -1;
    let redirectURL = (urlMapper[lastPath] || {})[isPrev ? 'allPrev' : 'allNext']
    if (!isAllModification) {
      redirectURL = 'client-login';
    }
    return location.pathname.toLowerCase().replace(lastPath, redirectURL) + location.search;
  }
/**
 * segment detail pass on basis of segment type
 * @param enumType segemt type pass
 * @param investorId investor id passed
 * @returns The result of the Segment detail
 */
  optSegments(enumType: string, investorId: string) {
    let segmentDetails = [];
    let segmentControls = this.getRouteInfo('segment-details').inputs.segments;
    let minSegments = enumType == 'Cash' ? segmentControls.filter((segment) => ['NSECash', 'BSECash'].indexOf(segment.segmentName) > -1) : segmentControls;
    minSegments.forEach((segment, index) => {
      if (!segment.hidden) {
        let segmentDetail = new SegmentDetails();
        segmentDetail.isOpt = 'Y';
        segmentDetail.investorId = investorId;
        segmentDetail.segmentMasterDto = { id: segment.id, segmentName: segment.segmentName, segmentType: segment.segmentType };
        segmentDetails.push(segmentDetail);
      }
    });
    return segmentDetails
  }
/**
 * Getting IP address
 */
  getIP() {
    let RTCPeerConnection = window['RTCPeerConnection'] || window['mozRTCPeerConnection'] || window['webkitRTCPeerConnection'];
    let ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g;
    if (RTCPeerConnection) {
      let candidates = [];
      let connection = new RTCPeerConnection({
        "iceServers": [{
          "urls": ["stun:stun.l.google.com:19302"]
        }],
        "iceTransportPolicy": "all",
        "iceCandidatePoolSize": "0"
      });
      connection.onicecandidate = (event) => {
        if (event.candidate && event.candidate.candidate && event.candidate.candidate.trim()) {
          if (event.candidate && (event.candidate.address || '').match(ipRegex) || (event.candidate.address || '').indexOf('.local') > -1) {
            candidates.push(event.candidate.address || '');
          }
        }
      };
      connection.onicegatheringstatechange = () => {
        if (connection.iceGatheringState !== 'complete') {
          return;
        }
        this.storage.setItem('address', JSON.stringify(candidates))
        connection.close();
        connection = null;
      };
      connection.onicecandidateerror = (e) => {
        console.error('The server ' + e.url +
          ' returned an error with code=' + e.errorCode + ':\n' +
          e.errorText + '\n');
      }
      connection.createOffer({
        offerToReceiveAudio: 1
      }).then((desc) => {
        let fpString = desc.sdp.split('\n').find(sdpStr => sdpStr.indexOf('fingerprint') > -1);
        if (fpString) {
          this.storage.setItem('fingerprint', fpString.replace(/(?:\r\n|\r|\n)/g, ''));
        }
        connection.setLocalDescription(desc);
      }, (error) => {
      });
    }
  }
/**
 * Get compare value of string
 * @param strA passing string one
 * @param strB passing string two
 * @returns Compared string value
 */
  compareString(strA: string, strB: string) {
    strA = strA ? strA.replace(/  +/g, ' ') : '';
    strB = strB ? strB.replace(/  +/g, ' ') : '';
    let lengthA = strA ? strA.trim().length : 0;
    let lengthB = strB ? strB.trim().length : 0;
    let equivalency = 0;
    let minLength = (lengthA > lengthB) ? lengthB : lengthA;
    let maxLength = (lengthA < lengthB) ? lengthB : lengthA;
    for (let i = 0; i < minLength; i++) {
      if (strA[i].toLowerCase() == strB[i].toLowerCase()) {
        equivalency++;
      }
    }
    let weight = equivalency / maxLength;
    return (weight * 100);
  }
/**
 * Getting extension
 * @param extn passing extension
 * @returns file extension
 */
  getFileType(extn) {
    return extn ? ((extn === 'jpg' || extn === 'png' || extn === 'bmp') ? 'Image' : 'PDF') : null;
  }
/**
 * Getting file size
 * @param bytes passing byte of file size
 * @returns file size
 */
  getFileSize(bytes) {
    const i = Math.floor(Math.log(bytes) / Math.log(1024)),
      sizes = ['b', 'Kb', 'Mb', 'Gb', 'Tb', 'Pb', 'Eb', 'Zb', 'Yb'];
    return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
  }
/**
 * store decrypted mobileIPV value 
 * @param res value of mobileIPV
 */
  setIPVOnMobileCheck(res: string) {
    this.storage.setItem('mobileIPV', btoa(res));
  }
/**
 * Getting mobileIPV
 * @returns  mobileIPV value 
 */
  getIPVOnMobileCheck() {
    let mobileIPV = this.storage.getItem('mobileIPV');
    return mobileIPV ? atob(mobileIPV) : '';
  }
/**
 * Remove IPV On Mobile Check
 */
  removeIPVOnMobileCheck() {
    if (this.storage && this.storage.getItem('mobileIPV')) {
      this.storage.removeItem('mobileIPV');
    }
  }
/**
 * Getting digi Locker Config
 * @returns digiLocker Config value
 */
  getDigiLockerConfig() {
    let data = this.storage.getItem('digiLockerConfig');
    if (data) return JSON.parse(data);
    return {};
  }
/**
 * set DigiLockerConfig
 * @param value passing digi Locker Config value 
 */
  setDigiLockerConfig(value: any) {
    let data = { ...this.getDigiLockerConfig(), ...value };
    this.storage.setItem('digiLockerConfig', JSON.stringify(data));
  }
/**
 * clear DigiLocker Config
 */
  clearDigiLockerConfig() {
    if (this.storage && this.storage.getItem('digiLockerConfig')) {
      this.storage.removeItem('digiLockerConfig');
    }
  }
/**
 * Get Respond Issue Data
 * @returns  Respond Issue Data
 */
  getRespondIssueData() {
    if (this.storage) {
      let data = this.storage.getItem(this.businessUnit + 'Respond');
      if (data) return JSON.parse(data);
    }
    return {};
  }
/**
 * updated Respond Issue Data
 * @param data passing update response data
 */
  updateRespondIssueData(data: any) {
    if (this.storage) {
      this.storage.setItem(this.businessUnit + 'Respond', JSON.stringify(data));
    }
  }
/**
 * Clear Response Issue
 */
  clearRespondIssueData() {
    if (this.storage && this.storage.getItem(this.businessUnit + 'Respond')) {
      this.storage.removeItem(this.businessUnit + 'Respond');
    }
  }
/**
 * Get value Digio IPV Config
 * @returns value Digio IPV Config
 */
  getDigioIPVConfig() {
    let data = this.storage.getItem('digioIPVConfig');
    if (data) return JSON.parse(data);
    return {};
  }
/**
 * store value Digio IPV Config
 * @param value passing value Digio IPV Config
 */
  setDigioIPVConfig(value: any) {
    let data = { ...this.getDigioIPVConfig(), ...value };
    this.storage.setItem('digioIPVConfig', JSON.stringify(data));
  }
/**
 * Clear Digio Selfie Config
 */
  clearDigioIPVConfig() {
    if (this.storage && this.storage.getItem('digioIPVConfig')) {
      this.storage.removeItem('digioIPVConfig');
    }
  }
/**
 * Getting Digio Selfie Config
 * @returns  Digio Selfie Config
 */
  getDigioSelfieConfig() {
    let data = this.storage.getItem('digioSelfieConfig');
    if (data) return JSON.parse(data);
    return {};
  }
/**
 * store json object Digio Selfie Config
 * @param value passing Digio Selfie Config
 */
  setDigioSelfieConfig(value: any) {
    let data = { ...this.getDigioSelfieConfig(), ...value };
    this.storage.setItem('digioSelfieConfig', JSON.stringify(data));
  }
/**
 * Clear Digio Selfie Config
 */
  clearDigioSelfieConfig() {
    if (this.storage && this.storage.getItem('digioSelfieConfig')) {
      this.storage.removeItem('digioSelfieConfig');
    }
  }
/**
 * Getting value base on key name
 * @param key passing key name
 * @returns value base on key name
 */
  getSessionStorageValue(key: string) {
    let data = this.storage.getItem(key);
    return data;
  }
/**
 * set session storage value base on key and value
 * @param key passing key name
 * @param value passing key value
 */
  setSessionStorageValue(key: string, value: any) {
    this.storage.setItem(key, value);
  }
/**
 * base on key value it will clear in session storage
 * @param key passing key value
 */
  clearSessionStorageKey(key: string) {
    if (this.storage && this.storage.getItem(key)) {
      this.storage.removeItem(key);
    }
  }

  /**
  * To download file from server
  * @param path file path
  * @param fileName file name to be display
  */
  downloadFile(path, fileName) {
    fetch(path)
      .then(resp => resp.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        // the filename you want
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        // alert('your file has downloaded!'); // or you know, something with better UX...
      })
      .catch(() =>
        this.error('Error', 'Something went wrong. Please try again later.')
      );
  }
  /**
   * Get Mobile Number Regex
   * @returns Mobile Number Regex
   */
  public getMobileNumberRegex() {
    return mobileNumberRegex;
  }
  /**
   * Get Email Regex
   * @returns Email Regex
   */

  public getEmailRegex() {
    return emailRegex;
  }
  /**
   * Get PAN Regex
   * @returns PAN Regex
   */
  public getPANRegex() {
    return panNumberRegex;
  }
/**
 * Get Account Regex
 * @returns Account Regex
 */
  public getAccountRegex() {
    return accNoRegex;
  }
/**
 * Getting Passport Regex
 * @returns Passport Regex
 */
  public getPassportRegex() {
    return passportRegex;
  }
  /**
   * Get Voter Regex
   * @returns VoterRegex
   */

  public getVoterRegex() {
    return voterRegex;
  }
/**
 * Get Aadhaar Regex
 * @returns Aadhaar Regex
 */
  public getAadhaarRegex() {
    return aadhaarRegex;
  }
/**
 * Get AlphaNumericRegex
 * @returns AlphaNumeric Regex
 */
  public getAlphaNumericRegex() {
    return alphaNumericRegex;
  }
/**
 * update Modification API Request
 * @param data passing data of Modification API Request
 */
  updateModificationAPIRequestData(data: any) {
    this.modification = data;
    if (this.storage) {
      this.storage.setItem(this.businessUnit + 'ModificationAPIRequest', JSON.stringify(this.modification));
    }
  }
/**
 * get Modification API Request
 * @returns Modification API Request value
 */
  getModificationAPIRequestData() {
    if (this.storage) {
      let data = this.storage.getItem(this.businessUnit + 'ModificationAPIRequest');
      // console.log('DDD',data);
      if (data) return JSON.parse(data);
      return this.modification;
    }
    return this.modification;
  }
/**
 * Getting isCentkart value
 * @returns get value
 */
  getIsFromCentkart() {
    let data = this.storage.getItem('isCentkart');
    if (data) return data;
    return {};
  }
/**
 * store passed isCentkart value
 * @param value passing isCentkart value
 */
  setIsFromCentkart(value: any) {
    this.storage.setItem('isCentkart', value);
  }
/**
 * aaded data layer
 * @param eventName passing event name
 * @param customEvent passing custom Event name
 */
  addDataLayer(eventName, customEvent?: any) {
    const scriptElement = document.createElement('script');
    let scripInnerHtml =  customEvent? 'window.dataLayer = window.dataLayer || [];window.dataLayer.push({event:"' + eventName + '",investorId:"'+ customEvent + '"})': 'window.dataLayer = window.dataLayer || [];window.dataLayer.push({event:"' + eventName + '"})';
    scriptElement.textContent = scripInnerHtml;
    document.head.appendChild(scriptElement);
  }
/**
 * aaded data layer
 * @param eventName passing event name
 * @param customEvent passing custom Event name
 */
  addDataLayer2(eventName, customEvent?: any) {
    const scriptElement = document.createElement('script');
    let scripInnerHtml =  'window.dataLayer = window.dataLayer || [];window.dataLayer.push({event:"' + eventName + '"})';
    scriptElement.textContent = scripInnerHtml;
    document.head.appendChild(scriptElement);
  }

  
  /**
   * push event using datalayer
   * @param eventData passing event data
   */
  pushDataLayerEvent(eventData) {
    // let window = windo
    // (window as any).dataLayer = (window as any).dataLayer || [];
    // (window as any).dataLayer.push(eventData);
  } 

   
    /**
     * Secure mobile number for user events in GA4
     * @param input values
     * @returns values
     */
  generateSHA256Hash(input){
    // console.log('INPUT',input)
    // console.log('Output',cryptoJs.SHA256(input).toString())
    if(input){
      return cryptoJs.SHA256(input).toString();
    }else{
      return "";
    }
  }
/**
 * initialize Education List Version 2
 */
  private initializeEducationListV2() {
    this.rest.retrieveEducationListsV2().subscribe((res) => {
      if (res && res.Body && res.Body.EducationMasterList) {
        this.config.educations = res.Body.EducationMasterList;
      }
    });
  }
/**
 * update Dormant Status
 * @param status Dormant Status
 */
  updateDormantStatus(status) {
    if (this.storage) {
      this.storage.setItem(this.businessUnit+'DormantStatus', status);
    }
  }
/**
 * get Dormant Status
 * @returns Dormant Status
 */
  getDormantStatus() {
    if (this.storage) {
      let status = this.storage.getItem(this.businessUnit+'DormantStatus');
      if (status) return status;
      return null;
    }
    return null;
  }

  
  /**
   * public function to trigger intializeflowpoints from outside class
   */
  public triggerconfigList(){
    this.setValidationLang();
    this.initializeFlowPoints();
  }

  /**function to set the validation languges */
 
  public setValidationLang() {
    if(this.selectedLanguage && this.selectedLanguage === 'hi'){
      this.errorMessages = validationtext[1];
      // console.log('MSG',this.errorMessages.pan_required)
    }

    if(this.selectedLanguage && this.selectedLanguage === 'en'){
      this.errorMessages = validationtext[0]
      // console.log('MSG',this.errorMessages.pan_required)
    }
  }

  /**store security params in session storage. */
  // storeSecurityParams() {
  //   console.log('secureP',this.secureParams)
  //   for (const [key, value] of Object.entries(this.secureParams)) {
  //     sessionStorage.setItem(`${key}`, value.toString())
  //   }
  // }

  /**generate Access token for API's */
  generateAccessToken(): any{

    let payload = {};
    payload['investor_id'] = sessionStorage.getItem('invid') ? sessionStorage.getItem('invid'):sessionStorage.getItem('investorId') ? sessionStorage.getItem('investorId')  : null;
    payload['code'] =  sessionStorage.getItem('code') ? sessionStorage.getItem('code') : null;
    payload['request_type'] = '';

    
    this.rest.getAccessTokenURL(payload).subscribe((res) => {
      if(res && res.Body && res.Body.access_token){
          sessionStorage.setItem('access_token',res.Body.access_token)
          this.shared.tokenSuccess.next(res);
          // this.subject2.next(res);
      }
    },(error) => {
      console.log('ONB error',error)
      if(error.error.Message && error.status == 401){
          // this.toastr.error(error.error.Message);
        // this.showModal({
        //         title: 'Unauthorized Access',
        //         message: error.error.Message,
        //         actions: [
        //           {
        //             label: 'OKAY',
        //             handler: () => {
        //               window.open('https://dev.choiceindia.com/open-free-demat-account',"_self");
        //               this.utils.modalConfig = null;
        //             }
        //           }
        //         ]
        //       })
        this.shared.tokenFailure.next(sessionStorage.getItem('requestFrom') || null);

          // setTimeout(() => {
          //   console.log('timeouterror')
          //   return false;
          // },3000)
          // this.subject2.next(error);
      }else{
            this.showModal({
                title: 'Invalid Request',
                message: "We're sorry, but you don't have permission to access the requested page. For security reasons, we need to re-authenticate you. To proceed, please click 'OK' and enter your mobile number and OTP on the next page to continue onboarding",
                actions: [
                  {
                    label: 'OKAY',
                    handler: () => {
                      window.open('https://choiceindia.com/open-free-demat-account',"_self");
                      this.utils.modalConfig = null;
                    }
                  }
                ]
              })
        // this.toastr.error(error.error.Message? error.error.Message: 'Something went wrong. Please try again later.')
        // this.subject2.next(error);
      }
    })
  }

  /**
   * Function to decrypt encrypted data
   * @param text Passing text
   * @returns decrypted data
   */
   static decryptText(text: string): string {
    if (text) {
      let key = cryptoJs.enc.Utf8.parse('');
      let iv = cryptoJs.enc.Utf8.parse('');
      let config = { keySize: 256, iv: iv, mode: cryptoJs.mode.CBC, padding: cryptoJs.pad.Pkcs7 };
      try {
        let encPassword = cryptoJs.AES.decrypt(text, key, config);
        return encPassword.toString(cryptoJs.enc.Utf8);
      } catch (err) {
        try {
          return JSON.parse(text)
        } catch (err1) {
          return text || ''
        }
      }
    } else {
      return ''
    }
  }

/**
 * update  InvestorDetails latest
 * @param callback callback function
 * @param hideLoader  loader boolean value
 * @param contactUpdationType  contact Updation Type
 */
  updateInvestorDetailsNew(callback?: Function, hideLoader?: boolean, contactUpdationType?:string) {
    let deviceID = this.getOS();
    this.rest.showLoader("Saving your details..");
    this.investor.deviceID = deviceID;
    this.investor.lid = this.getLMSId() || this.investor.lid || null;
    this.investor.entityId = this.getEntityId() || this.investor.entityId || null;
    if (this.investor.investorAccountDetailsDtoList && this.investor.investorAccountDetailsDtoList.length) {
      let investorDetails = ((this.investor.investorDetailsDtoList || [])[0] || new InvestorDetails());
      this.investor.investorAccountDetailsDtoList[0].deviceID = deviceID;
      let investorAccount = ((this.investor.investorAccountDetailsDtoList || [])[0] || new InvestorAccount());
      let isAlphabee = ((this.getLMSData(this.businessUnit) || {}).leadSource || '').toLowerCase().indexOf('alphabee') > -1
      
      this.investor.investorAccountDetailsDtoList[0].originalSource = this.getOnboardingType() == 'REFERRAL' ? 'JIFFY_OFFLINE' : this.getOnboardingType() == 'Alphabee' || isAlphabee ? 'ALPHABEE' : (this.getSource() || this.getOriginalSource());
      investorAccount.referredID = (isAlphabee) ? null : (investorAccount.referredID || this.getReferCode() || '')
      location.pathname.indexOf('/review') == -1 ? this.investor.investorAccountDetailsDtoList[0].isReviewed = 'N' : '';
      this.investor.investorAccountDetailsDtoList[0].referredID = this.investor.investorAccountDetailsDtoList[0].referredID || this.getReferCode();
      // || 'Annual AMC Plan'
      this.investor.investorAccountDetailsDtoList[0].plan = this.investor.investorAccountDetailsDtoList[0].plan;
      investorDetails.politicalRelation = (investorDetails.politicalRelation && investorDetails.politicalRelation==='N') ? 'NPEP_NRPEP' : investorDetails.politicalRelation;
      let screenObject = this.assignScreen(this.investor.investorAccountDetailsDtoList[0]);
      if (screenObject) {
        this.investor.investorAccountDetailsDtoList[0].screenName = (screenObject.step && screenObject.step.label) || screenObject.label || '';
        this.investor.investorAccountDetailsDtoList[0].screenIdentifierId = (screenObject.screen && screenObject.screen.id) || screenObject.id || '1';
      }
    }
    if (this.businessUnit != 'MF') {
      let investorAccount = ((this.investor.investorAccountDetailsDtoList || [])[0] || new InvestorAccount());
      let isAlphabee = (investorAccount.originalSource) ? investorAccount.originalSource.toLowerCase().indexOf('alphabee') > -1 : '';
      // let obtype = ((this.getLMSData(this.businessUnit) || {}).leadSource || '').toLowerCase().indexOf('alphabee') > -1;
      investorAccount.referredID = (isAlphabee) ? null : (investorAccount.referredID || this.getReferCode() || '')
      this.investor.investorSegmentDtoList = (isAlphabee) ? this.optSegments(isAlphabee ? 'Cash' : 'All', this.investor.id) : this.investor.investorSegmentDtoList;
      // && this.investor.investorSegmentDtoList.length ? this.investor.investorSegmentDtoList : this.optSegments(isAlphabee ? 'Cash' : 'All', this.investor.id);
      let investorDetails = ((this.investor.investorDetailsDtoList || [])[0] || new InvestorDetails());
      investorDetails.incomeSlab = investorDetails.incomeSlab || '1-5 Lacs';
      investorDetails.education = investorDetails.education || 'Graduate';
      investorDetails.experience = investorDetails.experience || '0';
      investorDetails.politicalRelation = (investorDetails.politicalRelation && investorDetails.politicalRelation==='N') ? 'NPEP_NRPEP' : investorDetails.politicalRelation;
      this.investor.investorDetailsDtoList = [investorDetails];
      this.investor.investorAccountDetailsDtoList = [investorAccount];
    }

    if (callback) callback();
    // this.rest.updateInvestor(this.investor, this.investor.id, hideLoader, contactUpdationType).subscribe((res) => {
    //   this.rest.hideLoader();
    //   if (res && res.errorCode == '9999' || res.errorCode == '0053') {
    //     this.error('Error', res.message);
    //   } else if (res && res.errorCode == '0054') {
    //     let lmsData = this.getLMSData(this.businessUnit);
    //     let msg = 'Record with your name: <b>' + lmsData.firstName + '</b> and mobile number: <b>' + lmsData.mobileNo1 + '</b> already exists';
    //     this.showModal({
    //       title: 'Attention!!',
    //       message: msg,
    //       actions: [
    //         {
    //           label: this.errorMessages.okaybtn,
    //           handler: () => {
    //             this.utils.modalConfig = null;
    //             location.href = this.getRedirectionURL('signUpURL');
    //           }
    //         }
    //       ]
    //     })
    //   }
    //   else if (res && !res.errorCode) {
    //     this.investor = res;
    //     this.setStep();
    //     this.updateScreenDetails(hideLoader);
    //     this.updateOnboardingData(this.investor);
    //     if (callback) callback();
    //   }
    // },
    //   error => {
    //     this.rest.hideLoader();
    //   })
  }

  /**
   * Function to encrpt data
   * @param plainText passing text
   * @returns encrpt data
   */
  public encryptText(plainText: string): string {
    if (plainText) {
      let key = cryptoJs.enc.Utf8.parse('');
      let iv = cryptoJs.enc.Utf8.parse('');
      let config = { keySize: 256, iv: iv, mode: cryptoJs.mode.CBC, padding: cryptoJs.pad.Pkcs7 };
      let encPassword = cryptoJs.AES.encrypt(plainText, key, config);
      return encPassword.ciphertext.toString(cryptoJs.enc.Base64);
    } else {
      return ''
    }
  }  


}

/**
 * Here we provide date range used 
 * @param min  minimum date
 * @param max  maximum date
 * @returns Range Value
 */
export function range(min: number | Date, max: number | Date): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    return !control.value || (new Date(control.value).valueOf() >= min && new Date(control.value).valueOf() <= max) ? null : { range: true };
  }
}
